export const SlotPatform = [
  {
    img: "/assets/icon/rng_jili.webp",
    key: "JILI",
    selected: "/assets/icon/rng_jili_dark.webp",
    imgWeb: "/assets/icon/jili.svg",
  },
  {
    img: "/assets/icon/rng_pp.webp",
    key: "PP",
    selected: "/assets/icon/rng_pp_dark.webp",
    imgWeb: "/assets/icon/pp.svg",
  },
  {
    img: "/assets/icon/rng_pt.webp",
    key: "PT",
    selected: "/assets/icon/rng_pt_dark.webp",
    imgWeb: "/assets/icon/pt.svg",
  },
  {
    img: "/assets/icon/rng_netent.webp",
    key: "NETENT",
    selected: "/assets/icon/rng_netent_dark.webp",
    imgWeb: "/assets/icon/netent.svg",
  },
  {
    img: "/assets/icon/rng_jdb.webp",
    key: "JDB",
    selected: "/assets/icon/rng_jdb_dark.webp",
    imgWeb: "/assets/icon/jdb.svg",
  },
  {
    img: "/assets/icon/rng_pg.webp",
    key: "PG",
    selected: "/assets/icon/rng_pg_dark.webp",
    imgWeb: "/assets/icon/pg.svg",
  },
  {
    img: "/assets/icon/rng_spg.webp",
    selected: "/assets/icon/rng_spg_dark.webp",
    imgWeb: "/assets/icon/spg.svg",
    key: "SPADE",
  },
  {
    img: "/assets/icon/rng_rt.webp",
    selected: "/assets/icon/rng_rt_dark.webp",
    imgWeb: "/assets/icon/rt.svg",
    key: "RT",
  },
  {
    img: "/assets/icon/rng_nolimit.webp",
    selected: "/assets/icon/rng_nolimit_dark.webp",
    imgWeb: "/assets/icon/nolimit.svg",
    key: "NOLIMIT",
  },
];
export const CasinoPatformInner = [
  {
    img: "/assets/icon/evo_avatar.webp",
    key: "EVO",
    selected: "/assets/icon/evo_dark.webp",
    imgWeb: "/assets/icon/evo.svg",
  },
  {
    img: "/assets/icon/rng_pp.webp",
    selected: "/assets/icon/rng_pp_dark.webp",
    key: "PP",
    imgWeb: "/assets/icon/pp.svg",
  },
  {
    img: "/assets/icon/sexy_v2_avatar.webp",
    key: "SEXY",
    selected: "/assets/icon/sexy_v2_dark.webp",
    imgWeb: "/assets/icon/sexy_v2.svg",
  },

  {
    img: "/assets/icon/rng_pt.webp",
    key: "PT",
    selected: "/assets/icon/rng_pt_dark.webp",
    imgWeb: "/assets/icon/pt.svg",
  },
];
export const CasinoPlatform = [
  {
    img: "/assets/icon/ld_evo.webp",
    key: "EVO",
  },
  {
    img: "/assets/icon/ld_pp.webp",
    key: "PP",
  },
  {
    img: "/assets/icon/ld_sexy_v2.webp",
    key: "SEXY",
  },
  {
    img: "/assets/icon/ld_pt.webp",
    key: "PT",
  },
];

export const CrashPlatform = [
  {
    img: "/assets/icon/crash_aviator.jpg",
    key: "AVIATOR",
    selected: "/assets/icon/aviator_dark.webp",
    imgWeb: "/assets/icon/aviator.svg",
  },
  {
    img: "/assets/icon/crash_spribe.webp",
    key: "SPRIBE",
    selected: "/assets/icon/spribe_dark.webp",
    imgWeb: "/assets/icon/spribe.svg",
  },
  {
    img: "/assets/icon/crash_jili.webp",
    key: "JILI",
    selected: "/assets/icon/rng_jili_dark.webp",
    imgWeb: "/assets/icon/jili.svg",
  },
];

export const TablePlatform = [
  {
    img: "/assets/icon/table_jili.webp",
  },
  {
    img: "/assets/icon/table_sexy_v2.webp",
  },
];
export const TablePlatformInner = [
  {
    img: "/assets/icon/crash_jili.webp",
    key: "JILI",
    selected: "/assets/icon/rng_jili_dark.webp",
    imgWeb: "/assets/icon/jili.svg",
  },
  {
    img: "/assets/icon/km.webp",
    key: "KM",
    selected: "/assets/icon/km_dark.webp",
    imgWeb: "/assets/icon/sexy_v2.svg",
  },
];

export const FishingPlatform = [
  {
    img: "/assets/images/fishing_jili.webp",
    key: "JILI",
  },
  {
    img: "/assets/images/fishing_spg.webp",
    key: "SPADE",
  },
];
export const FishingPatformInner = [
  {
    img: "/assets/icon/rng_jili.webp",
    key: "JILI",
    selected: "/assets/icon/rng_jili_dark.webp",
    imgWeb: "/assets/icon/jili.svg",
  },

  {
    img: "/assets/icon/rng_spg.webp",
    key: "SPADE",
    selected: "/assets/icon/rng_spg_dark.webp",
    imgWeb: "/assets/icon/spg.svg",
  },
];
export const CricketPlatform = [
  {
    img: "/assets/images/cricket_wicketspro_BDT.jpg",
    key: "9 Wickets",
  },
  {
    img: "/assets/images/cricket-velki.webp",
    key: "Velkie",
  },
];

export const HomeJackpot = [
  {
    img: "/assets/jackpot/49_0.webp",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-027",
    name: "Super Ace",
  },
  {
    img: "/assets/jackpot/64a539adb4510.webp",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-076",
    name: "Fortune Gems 2",
  },
  {
    img: "/assets/jackpot/51_0.webp",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-029",
    Name: "Money Coming",
  },
  {
    img: "/assets/jackpot/134_0.webp",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-051",
    Name: "Mega Ace",
  },
  {
    img: "/assets/jackpot/103_0.webp",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-042",
    Name: "Golden Empire",
  },
  {
    img: "/assets/jackpot/35_0.webp",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-013",
    Name: "SevenSevenSeven",
  },
  {
    img: "/assets/jackpot/6704982c17276.webp",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-112",
    Name: "Money Pot",
  },
  {
    img: "/assets/jackpot/646490e8c2eea.webp",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-075",
    Name: "Wild Ace",
  },
  {
    img: "/assets/jackpot/30_0.webp",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-015",
    Name: "Bubble Beauty",
  },
  {
    img: "/assets/jackpot/47_0.webp",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-026",
    Name: "Charge Buffalo",
  },
  {
    img: "/assets/jackpot/6448f47d4aab4.webp",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-074",
    Name: "Golden Joker",
  },
  {
    img: "/assets/jackpot/66bac064120d4.webp",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-109",
    Name: "3 Lucky Piggy",
  },
  {
    img: "/assets/jackpot/654d975af350c.webp",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-135",
    Name: "Pirate Queen 2 ",
  },
  {
    img: "/assets/jackpot/102_0.webp",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-155",
    Name: "ROMA X 10000",
  },
  {
    img: "/assets/jackpot/64ec0e29f2fe6.webp",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-081",
    Name: "Elf Bingo",
  },
  {
    img: "/assets/jackpot/6527bc5ee1def.webp",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-085",
    Name: "Devil Fire",
  },
  {
    img: "/assets/jackpot/64881eb6a43d8.webp",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-077",
    Name: "Master Tiger",
  },
  {
    img: "/assets/jackpot/650c05aaeca2c.webp",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-080",
    Name: "Golden Temple",
  },
  {
    img: "/assets/jackpot/65694a3d9a86a.webp",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-060",
    Name: "JILI CAISHEN",
  },
  {
    img: "/assets/jackpot/673dc5075a18a.webp",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-091",
    Name: "King Arthur",
  },
];

export const HotGames = [
  {
    img: "/assets/hot/6879f6c5b1382.webp",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-043",
    Name: "Fortune Gems",
  },
  {
    img: "/assets/hot/682bb30722524.webp",
    platFormCode: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-001",
    Name: "Aviator",
  },
  {
    img: "/assets/hot/49_0.webp",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-027",
    Name: "Super Ace",
  },
  {
    img: "/assets/hot/avx_nft_aviatrix.webp",
    platFormCode: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-022",
    Name: "Aviator Extra Bet",
  },
  {
    img: "/assets/hot/77_0.webp",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-031",
    Name: "Boxing King",
  },
  {
    img: "/assets/hot/668955e4c9622.webp",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-102",
    Name: "Super Ace Deluxe",
  },
  {
    img: "/assets/hot/64a539adb4510.webp",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-076",
    Name: "Fortune Gems 2",
  },
  {
    img: "/assets/hot/51_0.webp",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-029",
    Name: "Money Coming",
  },
  {
    img: "/assets/hot/evo_crazy_time.webp",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-006",
    Name: "Crazy Time",
  },
  {
    img: "/assets/hot/6704982c17276.webp",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-112",
    Name: "Money Pot",
  },
  {
    img: "/assets/hot/spb_aviator.webp",
    platFormCode: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-001",
    Name: "Aviator",
  },
  {
    img: "/assets/hot/evo_funky_time.webp",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-183",
    Name: "Funky Time",
  },
  {
    img: "/assets/hot/thumb.webp",
    platFormCode: "DRAGOONSOFT",
    gameType: "SLOT",
    casinoType: "DRAGOONSOFT-SLOT-050",
    Name: "Chicken Dinner",
  },
  {
    img: "/assets/hot/669f794e9a160.webp",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-146",
    Name: "Money Coming 2",
  },
  {
    img: "/assets/hot/68ca3dc64e710.webp",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-082",
    Name: "Chicken Dash",
  },
  {
    img: "/assets/hot/124_0.webp",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-011",
    Name: "7up7down",
  },
  {
    img: "/assets/hot/ppl_mega_wheel.webp",
    gameType: "LIVE",
    casinoType: "PP-LIVE-038",
    Name: "Mega Wheel",
    platFormCode: "PP",
  },
  {
    img: "/assets/hot/134_0.webp",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-051",
    Name: "Mega Ace",
  },
];

export const CasinoList = [
  {
    img: "/assets/casinoList/MX-LIVE-002_0.webp",
    platform: "SEXY",
    name: "Ae Sexy Baccarat",
    platFormCode: "SEXYBCRT",
    gameType: "LIVE",
    casinoType: "MX-LIVE-001",
  },
  {
    img: "/assets/casinoList/evo_funky_time.webp",
    platform: "EVO",
    name: "Funky Time",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-183",
  },
  {
    img: "/assets/casinoList/evo_crazy_time.webp",
    platform: "EVO",
    name: "Crazy Time",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-006",
  },
  // {
  //   img: "/assets/casinoList/evo_salon_priv_autoroulette_a.webp",
  //   platform: "EVO",
  //   name: "Salon Privé Auto-Roulette A",
  // },
  // {
  //   img: "/assets/casinoList/evo_super_speed_dragon_tiger.webp",
  //   platform: "EVO",
  //   name: "Super Speed Dragon Tiger",
  // },
  // {
  //   img: "/assets/casinoList/evo_japanese_platinum_private_blackjack_1.webp",
  //   platform: "EVO",
  //   name: "Japanese Platinum Private Blackjack 1",
  // },
  // {
  //   img: "/assets/casinoList/evo_korean_platinum_private_blackjack_1.webp",
  //   platform: "EVO",
  //   name: "Korean Platinum Private Blackjack 1",
  // },
  // {
  //   img: "/assets/casinoList/evo_korean_platinum_private_blackjack_2.webp",
  //   platform: "EVO",
  //   name: "Korean Platinum Private Blackjack 2",
  // },
  // {
  //   img: "/assets/casinoList/evo_korean_lightning_baccarat.webp",
  //   platform: "EVO",
  //   name: "Korean Lightning Baccarat",
  // },
  // {
  //   img: "/assets/casinoList/evo_korean_speed_blackjack_h.webp",
  //   platform: "EVO",
  //   name: "Korean Speed Blackjack H",
  // },
  // {
  //   img: "/assets/casinoList/evo_korean_speed_blackjack_i.webp",
  //   platform: "EVO",
  //   name: "Korean Speed Blackjack I",
  // },
  // {
  //   img: "/assets/casinoList/evo_korean_speed_blackjack_j.webp",
  //   platform: "EVO",
  //   name: "Korean Speed Blackjack J",
  // },
  // {
  //   img: "/assets/casinoList/evo_korean_speed_blackjack_k.webp",
  //   platform: "EVO",
  //   name: "Korean Speed Blackjack K",
  // },
  // {
  //   img: "/assets/casinoList/evo_korean_speed_blackjack_l.webp",
  //   platform: "EVO",
  //   name: "Korean Speed Blackjack L",
  // },
  // {
  //   img: "/assets/casinoList/evo_korean_speed_blackjack_m.webp",
  //   platform: "EVO",
  //   name: "Korean Speed Blackjack M",
  // },
  {
    img: "/assets/casinoList/evo_ice_fishing.webp",
    platform: "EVO",
    name: "Ice Fishing",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-449",
  },
  {
    img: "/assets/casinoList/evo_korean_lightning_dragon_tiger.webp",
    platform: "EVO",
    name: "Korean Lightning Dragon Tiger",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-344",
  },
  // {
  //   img: "/assets/casinoList/evo_baccarat_rpido_ao_vivo_3.webp",
  //   platform: "EVO",
  //   name: "Baccarat Rápido ao Vivo 3",
  // },
  // {
  //   img: "/assets/casinoList/evo_baccarat_rpido_ao_vivo_1.webp",
  //   platform: "EVO",
  //   name: "Baccarat Rápido ao Vivo 1",
  // },
  // {
  //   img: "/assets/casinoList/evo_blackjack_em_portugus_1.webp",
  //   platform: "EVO",
  //   name: "Blackjack em Português 1",
  // },
  // {
  //   img: "/assets/casinoList/evo_ruleta_en_vivo.webp",
  //   platform: "EVO",
  //   name: "Ruleta en Vivo",
  // },
  // {
  //   img: "/assets/casinoList/evo_blackjack_em_portugus_ouro.webp",
  //   platform: "EVO",
  //   name: "Blackjack em Português Ouro",
  // },
  // {
  //   img: "/assets/casinoList/evo_blackjack_en_espaol_1.webp",
  //   platform: "EVO",
  //   name: "Blackjack en Español 1",
  // },
  // {
  //   img: "/assets/casinoList/evo_blackjack_en_espaol_2.webp",
  //   platform: "EVO",
  //   name: "Blackjack en Español 2",
  // },
  // {
  //   img: "/assets/casinoList/evo_blackjack_en_espaol_3.webp",
  //   platform: "EVO",
  //   name: "Blackjack en Español 3",
  // },
  // {
  //   img: "/assets/casinoList/evo_easy_blackjack_em_portugus.webp",
  //   platform: "EVO",
  //   name: "Easy Blackjack em Português",
  // },
  // {
  //   img: "/assets/casinoList/evo_blackjack_ilimitado_ao_vivo.webp",
  //   platform: "EVO",
  //   name: "Blackjack Ilimitado Ao Vivo",
  // },
  // {
  //   img: "/assets/casinoList/evo_ruleta_bola_rapida_en_vivo.webp",
  //   platform: "EVO",
  //   name: "Ruleta Bola Rápida en Vivo",
  // },
  // {
  //   img: "/assets/casinoList/evo_bac_bo_ao_vivo.webp",
  //   platform: "EVO",
  //   name: "Bac Bo Ao Vivo",
  // },
  // {
  //   img: "/assets/casinoList/evo_blackjack_ilimitado_en_vivo.webp",
  //   platform: "EVO",
  //   name: "Blackjack Ilimitado en Vivo",
  // },
  // {
  //   img: "/assets/casinoList/evo_roleta_ao_vivo.webp",
  //   platform: "EVO",
  //   name: "Roleta ao Vivo",
  // },
  // {
  //   img: "/assets/casinoList/evo_ruleta_en_espaol.webp",
  //   platform: "EVO",
  //   name: "Ruleta en Español",
  // },
  // {
  //   img: "/assets/casinoList/evo_vip_blackjack_en_espaol_4.webp",
  //   platform: "EVO",
  //   name: "VIP Blackjack en Español 4",
  // },
  // {
  //   img: "/assets/casinoList/evo_vip_blackjack_em_portugus.webp",
  //   platform: "EVO",
  //   name: "VIP Blackjack em Português",
  // },
  // {
  //   img: "/assets/casinoList/evo_vip_blackjack_em_portugus_2.webp",
  //   platform: "EVO",
  //   name: "VIP Blackjack em Português 2",
  // },
  // {
  //   img: "/assets/casinoList/evo_vip_blackjack_em_portugus_3.webp",
  //   platform: "EVO",
  //   name: "VIP Blackjack em Português 3",
  // },
  // {
  //   img: "/assets/casinoList/evo_vip_blackjack_em_portugus_4.webp",
  //   platform: "EVO",
  //   name: "VIP Blackjack em Português 4",
  // },
  // {
  //   img: "/assets/casinoList/evo_vip_blackjack_em_portugus_5.webp",
  //   platform: "EVO",
  //   name: "VIP Blackjack em Português 5",
  // },
  // {
  //   img: "/assets/casinoList/evo_vip_blackjack_en_espaol.webp",
  //   platform: "EVO",
  //   name: "VIP Blackjack en Español",
  // },
  // {
  //   img: "/assets/casinoList/evo_vip_blackjack_en_espaol_2.webp",
  //   platform: "EVO",
  //   name: "VIP Blackjack en Español 2",
  // },
  // {
  //   img: "/assets/casinoList/evo_vip_blackjack_en_espaol_3.webp",
  //   platform: "EVO",
  //   name: "VIP Blackjack en Español 3",
  // },
  // {
  //   img: "/assets/casinoList/evo_vip_blackjack_en_espaol_5.webp",
  //   platform: "EVO",
  //   name: "VIP Blackjack en Español 5",
  // },
  // {
  //   img: "/assets/casinoList/evo_vip_blackjack_en_espaol_6.webp",
  //   platform: "EVO",
  //   name: "VIP Blackjack en Español 6",
  // },
  // {
  //   img: "/assets/casinoList/evo_vip_blackjack_en_espaol_7.webp",
  //   platform: "EVO",
  //   name: "VIP Blackjack en Español 7",
  // },
  // {
  //   img: "/assets/casinoList/evo_vip_blackjack_en_espaol_8.webp",
  //   platform: "EVO",
  //   name: "VIP Blackjack en Español 8",
  // },
  // {
  //   img: "/assets/casinoList/evo_vip_blackjack_en_espaol_9.webp",
  //   platform: "EVO",
  //   name: "VIP Blackjack en Español 9",
  // },
  {
    img: "/assets/casinoList/evo_lightning_bac_bo.webp",
    platform: "EVO",
    name: "Lightning Bac Bo",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-440",
  },
  {
    img: "/assets/casinoList/evo_fireball_roulette.webp",
    platform: "EVO",
    name: "Fireball Roulette",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-436",
  },
  {
    img: "/assets/casinoList/evo_super_color_game.webp",
    platform: "EVO",
    name: "Super Color Game",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-435",
  },
  // {
  //   img: "/assets/casinoList/evo_korean_dragon_tiger.webp",
  //   platform: "EVO",
  //   name: "Korean Dragon Tiger",
  // },
  {
    img: "/assets/casinoList/evo_marble_race.webp",
    platform: "EVO",
    name: "Marble Race",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-434",
  },
  {
    img: "/assets/casinoList/evo_war.webp",
    platform: "EVO",
    name: "War",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-431",
  },
  // {
  //   img: "/assets/casinoList/evo_korean_speed_baccarat_g.webp",
  //   platform: "EVO",
  //   name: "Korean Speed Baccarat G",
  // },
  // {
  //   img: "/assets/casinoList/evo_korean_speed_baccarat_h.webp",
  //   platform: "EVO",
  //   name: "Korean Speed Baccarat H",
  // },
  // {
  //   img: "/assets/casinoList/evo_japanese_prosperity_tree_baccarat.webp",
  //   platform: "EVO",
  //   name: "Japanese Prosperity Tree Baccarat",
  // },
  // {
  //   img: "/assets/casinoList/evo_first_person_bac_bo.webp",
  //   platform: "EVO",
  //   name: "First Person Bac Bo",
  // },
  {
    img: "/assets/casinoList/evo_bet_stacker_blackjack_2.webp",
    platform: "EVO",
    name: "VIP Bet Stacker Blackjack 2",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-423",
  },
  {
    img: "/assets/casinoList/evo_bet_stacker_blackjack_3.webp",
    platform: "EVO",
    name: "VIP Bet Stacker Blackjack 3",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-424",
  },
  {
    img: "/assets/casinoList/evo_bet_stacker_blackjack_4.webp",
    platform: "EVO",
    name: "VIP Bet Stacker Blackjack 4",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-425",
  },
  {
    img: "/assets/casinoList/evo_race_track.webp",
    platform: "EVO",
    name: "Race Track",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-426",
  },
  {
    img: "/assets/casinoList/evo_race_track_a.webp",
    platform: "EVO",
    name: "Race Track A",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-427",
  },
  {
    img: "/assets/casinoList/evo_classic_bet_stacker_blackjack.webp",
    platform: "EVO",
    name: "VIP Bet Stacker Blackjack 1",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-422",
  },
  {
    img: "/assets/casinoList/evo_emperor_golden_wealth_baccarat.webp",
    platform: "EVO",
    name: "Emperor Golden Wealth Baccarat",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-414",
  },
  // {
  //   img: "/assets/casinoList/evo_japanese_golden_wealth_baccarat.webp",
  //   platform: "EVO",
  //   name: "Japanese Golden Wealth Baccarat",
  // },
  // {
  //   img: "/assets/casinoList/evo_korean_salon_prive_baccarat.webp",
  //   platform: "EVO",
  //   name: "Korean Salon Prive Baccarat",
  // },
  // {
  //   img: "/assets/casinoList/evo_korean_speed_blackjack_f.webp",
  //   platform: "EVO",
  //   name: "Korean Speed Blackjack F",
  // },
  // {
  //   img: "/assets/casinoList/evo_korean_speed_blackjack_d.webp",
  //   platform: "EVO",
  //   name: "Korean Speed Blackjack D",
  // },
  // {
  //   img: "/assets/casinoList/evo_korean_speed_blackjack_e.webp",
  //   platform: "EVO",
  //   name: "Korean Speed Blackjack E",
  // },
  // {
  //   img: "/assets/casinoList/evo_gonzos_treasure_map.webp",
  //   platform: "EVO",
  //   name: "Gonzo’s Treasure Map",
  // },
  {
    img: "/assets/casinoList/evo_video_poker.webp",
    platform: "EVO",
    name: "Video Poker",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-227",
  },
  {
    img: "/assets/casinoList/evo_gold_vault_roulette.webp",
    platform: "EVO",
    name: "Gold Vault Roulette",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-228",
  },
  {
    img: "/assets/casinoList/evo_first_person_xxxtreme_lightning_roulette.webp",
    platform: "EVO",
    name: "First Person XXXtreme Lightning Roulette",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-226",
  },
  // {
  //   img: "/assets/casinoList/evo_xclusive_speed_baccarat_e.webp",
  //   platform: "EVO",
  //   name: "Xclusive Speed Baccarat E",
  // },
  // {
  //   img: "/assets/casinoList/evo_xclusive_speed_baccarat_c.webp",
  //   platform: "EVO",
  //   name: "Xclusive Speed Baccarat C",
  // },
  // {
  //   img: "/assets/casinoList/evo_xclusive_speed_baccarat_b.webp",
  //   platform: "EVO",
  //   name: "Xclusive Speed Baccarat B",
  // },
  // {
  //   img: "/assets/casinoList/evo_xclusive_speed_baccarat_a.webp",
  //   platform: "EVO",
  //   name: "Xclusive Speed Baccarat A",
  // },
  // {
  //   img: "/assets/casinoList/evo_xclusive_speed_baccarat_d.webp",
  //   platform: "EVO",
  //   name: "Xclusive Speed Baccarat D",
  // },
  {
    img: "/assets/casinoList/evo_imperial_quest.webp",
    platform: "EVO",
    name: "Imperial Quest",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-169",
  },
  // {
  //   img: "/assets/casinoList/evo_extra_chilli_epic_spins.webp",
  //   platform: "EVO",
  //   name: "Extra Chilli Epic Spins",
  // },
  {
    img: "/assets/casinoList/evo_crazy_time_a.webp",
    platform: "EVO",
    name: "Crazy Time A",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-114",
  },
  {
    img: "/assets/casinoList/evo_speed_baccarat_z.webp",
    platform: "EVO",
    name: "Speed Baccarat Z",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-167",
  },
  {
    img: "/assets/casinoList/evo_emperor_sic_bo_a.webp",
    platform: "EVO",
    name: "Emperor Sic Bo A",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-211",
  },
  // {
  //   img: "/assets/casinoList/evo_grand_korean_blackjack.webp",
  //   platform: "EVO",
  //   name: "Grand Korean Speed Blackjack",
  // },
  {
    img: "/assets/casinoList/evo_bonsai_speed_baccarat_b.webp",
    platform: "EVO",
    name: "Bonsai Speed Baccarat B",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-232",
  },
  {
    img: "/assets/casinoList/evo_bonsai_speed_baccarat_a.webp",
    platform: "EVO",
    name: "Bonsai Speed Baccarat A",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-231",
  },
  // {
  //   img: "/assets/casinoList/ppl_top_games_lobby.webp",
  //   platform: "PP",
  //   name: "Top games Lobby",
  // },
  {
    img: "/assets/casinoList/ppl_mega_wheel.webp",
    platform: "PP",
    name: "Mega Wheel",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-038",
  },
  {
    img: "/assets/casinoList/ppl_sweet_bonanza_candy_land.webp",
    platform: "PP",
    name: "Sweet Bonanza Candy Land",
    gameType: "LIVE",
    casinoType: "PP-LIVE-044",
    platFormCode: "PP",
  },
  {
    img: "/assets/casinoList/ppl_andar_bahar.webp",
    platform: "PP",
    name: "Andar Bahar",
    gameType: "LIVE",
    casinoType: "PP-LIVE-043",
    platFormCode: "PP",
  },
  {
    img: "/assets/casinoList/ppl_mega_roulette.webp",
    platform: "PP",
    name: "Mega Roulette",
    gameType: "LIVE",
    casinoType: "PP-LIVE-039",
    platFormCode: "PP",
  },
  {
    img: "/assets/casinoList/ppl_mega_sicbo.webp",
    platform: "PP",
    name: "Mega Sicbo",
    gameType: "LIVE",
    casinoType: "PP-LIVE-140",
    platFormCode: "PP",
  },
  {
    img: "/assets/casinoList/ppl_fortune_6_baccarat.webp",
    platform: "PP",
    name: "Fortune 6 Baccarat",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-047",
  },
  {
    img: "/assets/casinoList/ppl_dragon_tiger.webp",
    platform: "PP",
    name: "Dragon Tiger",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-004",
  },
  {
    img: "/assets/casinoList/ppl_speed_baccarat_1.webp",
    platform: "PP",
    name: "Speed Baccarat 1",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-159",
  },
  {
    img: "/assets/casinoList/ppl_baccarat_2.webp",
    platform: "PP",
    name: "Baccarat 2",
    gameType: "LIVE",
    casinoType: "PP-LIVE-002",
    platFormCode: "PP",
  },
  {
    img: "/assets/casinoList/ppl_roulette_3_macao.webp",
    platform: "PP",
    name: "Roulette 3 Macao",
    gameType: "LIVE",
    casinoType: "PP-LIVE-037",
    platFormCode: "PP",
  },
  {
    img: "/assets/casinoList/ppl_speed_baccarat_8.webp",
    platform: "PP",
    name: "Speed Baccarat 8",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-274",
  },
  // {
  //   img: "/assets/casinoList/ppl_roulette_9__the_club.webp",
  //   platform: "PP",
  //   name: "Roulette 9 - The Club",
  // },
  {
    img: "/assets/casinoList/ppl_baccarat_1.webp",
    platform: "PP",
    name: "Baccarat 1",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-001",
  },
  {
    img: "/assets/casinoList/ppl_speed_baccarat_2.webp",
    platform: "PP",
    name: "Speed Baccarat 2",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-160",
  },
  {
    img: "/assets/casinoList/ppl_speed_roulette_1.webp",
    platform: "PP",
    name: "Speed Roulette 1",
    gameType: "LIVE",
    casinoType: "PP-LIVE-027",
    platFormCode: "PP",
  },
  {
    img: "/assets/casinoList/ppl_autoroulette_1.webp",
    platform: "PP",
    name: "Auto-Roulette 1",
    gameType: "LIVE",
    casinoType: "PP-LIVE-060",
    platFormCode: "PP",
  },
  // {
  //   img: "/assets/casinoList/ppl_roulette_5_german.webp",
  //   platform: "PP",
  //   name: "Roulette 5 German",
  // },
  {
    img: "/assets/casinoList/ppl_speed_baccarat_9.webp",
    platform: "PP",
    name: "Speed Baccarat 9",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-250",
  },
  // {
  //   img: "/assets/casinoList/ppl_indonesian_mega_sic_bo.webp",
  //   platform: "PP",
  //   name: "Indonesian Mega Sic Bo",
  // },
  // {
  //   img: "/assets/casinoList/ppl_blackjack_155.webp",
  //   platform: "PP",
  //   name: "Blackjack 155",
  // },
  // {
  //   img: "/assets/casinoList/ppl_blackjack_157.webp",
  //   platform: "PP",
  //   name: "Blackjack 157",
  // },
  // {
  //   img: "/assets/casinoList/ppl_blackjack_156.webp",
  //   platform: "PP",
  //   name: "Blackjack 156",
  // },
  // {
  //   img: "/assets/casinoList/ppl_blackjack_153.webp",
  //   platform: "PP",
  //   name: "Blackjack 153",
  // },
  // {
  //   img: "/assets/casinoList/ppl_blackjack_154.webp",
  //   platform: "PP",
  //   name: "Blackjack 154",
  // },
  // {
  //   img: "/assets/casinoList/ppl_blackjack_151.webp",
  //   platform: "PP",
  //   name: "Blackjack 151",
  // },
  // {
  //   img: "/assets/casinoList/ppl_blackjack_152.webp",
  //   platform: "PP",
  //   name: "Blackjack 152",
  // },
  // {
  //   img: "/assets/casinoList/ppl_blackjack_150.webp",
  //   platform: "PP",
  //   name: "Blackjack 150",
  // },
  {
    img: "/assets/casinoList/ppl_roulette_2_extra_time.webp",
    platform: "PP",
    name: "Roulette 2 Extra Time",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-029",
  },
  // {
  //   img: "/assets/casinoList/ppl_blackjack_149.webp",
  //   platform: "PP",
  //   name: "Blackjack 149",
  // },
  // {
  //   img: "/assets/casinoList/ppl_blackjack_148.webp",
  //   platform: "PP",
  //   name: "Blackjack 148",
  // },
  // {
  //   img: "/assets/casinoList/ppl_blackjack_144.webp",
  //   platform: "PP",
  //   name: "Blackjack 144",
  // },
  // {
  //   img: "/assets/casinoList/ppl_blackjack_147.webp",
  //   platform: "PP",
  //   name: "Blackjack 147",
  // },
  // {
  //   img: "/assets/casinoList/ppl_blackjack_146.webp",
  //   platform: "PP",
  //   name: "Blackjack 146",
  // },
  // {
  //   img: "/assets/casinoList/ppl_blackjack_145.webp",
  //   platform: "PP",
  //   name: "Blackjack 145",
  // },
  // {
  //   img: "/assets/casinoList/ppl_blackjack_143.webp",
  //   platform: "PP",
  //   name: "Blackjack 143",
  // },
  // {
  //   img: "/assets/casinoList/ppl_indonesian_one_blackjack.webp",
  //   platform: "PP",
  //   name: "Indonesian ONE Blackjack",
  // },
  // {
  //   img: "/assets/casinoList/ppl_korean_one_blackjack.webp",
  //   platform: "PP",
  //   name: "Korean ONE Blackjack",
  // },
  {
    img: "/assets/casinoList/ppl_priv_lounge_roulette_deluxe.webp",
    platform: "PP",
    name: "Privé Lounge Roulette Deluxe",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-184",
  },
  // {
  //   img: "/assets/casinoList/ppl_priv_lounge_blackjack_13.webp",
  //   platform: "PP",
  //   name: "Privé Lounge Blackjack 13",
  // },
  // {
  //   img: "/assets/casinoList/ppl_priv_lounge_blackjack_14.webp",
  //   platform: "PP",
  //   name: "Privé Lounge Blackjack 14",
  // },
  {
    img: "/assets/casinoList/ppl_dice_city.webp",
    platform: "PP",
    name: "Dice City",
    gameType: "LIVE",
    casinoType: "PP-LIVE-049",
    platFormCode: "PP",
  },
  // {
  //   img: "/assets/casinoList/ppl_priv_lounge_blackjack_11.webp",
  //   platform: "PP",
  //   name: "Privé Lounge Blackjack 11",
  // },
  // {
  //   img: "/assets/casinoList/ppl_priv_lounge_blackjack_12.webp",
  //   platform: "PP",
  //   name: "Privé Lounge Blackjack 12",
  // },
  {
    img: "/assets/casinoList/ppl_jacks_or_better_draw_poker.webp",
    platform: "PP",
    name: "Jacks or Better Draw Poker",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-183",
  },
  // {
  //   img: "/assets/casinoList/ppl_priv_lounge_roulette.webp",
  //   platform: "PP",
  //   name: "Privé Lounge Roulette",
  // },
  {
    img: "/assets/casinoList/ppl_casino_holdem.webp",
    platform: "PP",
    name: "Casino Hold'em",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-015",
  },
  {
    img: "/assets/casinoList/ppl_french_roulette.webp",
    platform: "PP",
    name: "French Roulette",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-181",
  },
  // {
  //   img: "/assets/casinoList/ppl_blackjack_137.webp",
  //   platform: "PP",
  //   name: "Blackjack 137",
  // },
  // {
  //   img: "/assets/casinoList/ppl_blackjack_141.webp",
  //   platform: "PP",
  //   name: "Blackjack 141",
  // },
  // {
  //   img: "/assets/casinoList/ppl_blackjack_135.webp",
  //   platform: "PP",
  //   name: "Blackjack 135",
  // },
  // {
  //   img: "/assets/casinoList/ppl_blackjack_136.webp",
  //   platform: "PP",
  //   name: "Blackjack 136",
  // },
  // {
  //   img: "/assets/casinoList/ppl_blackjack_138.webp",
  //   platform: "PP",
  //   name: "Blackjack 138",
  // },
  // {
  //   img: "/assets/casinoList/ppl_blackjack_139.webp",
  //   platform: "PP",
  //   name: "Blackjack 139",
  // },
  // {
  //   img: "/assets/casinoList/ppl_blackjack_140.webp",
  //   platform: "PP",
  //   name: "Blackjack 140",
  // },
  // {
  //   img: "/assets/casinoList/ppl_blackjack_142.webp",
  //   platform: "PP",
  //   name: "Blackjack 142",
  // },
  {
    img: "/assets/casinoList/ppl_indonesian_blackjackx_16.webp",
    platform: "PP",
    name: "Indonesian BlackjackX 16",
    gameType: "LIVE",
    casinoType: "PP-LIVE-170",
    platFormCode: "PP",
  },
  {
    img: "/assets/casinoList/ppl_indonesian_blackjackx_17.webp",
    platform: "PP",
    name: "Indonesian BlackjackX 17",
    gameType: "LIVE",
    casinoType: "PP-LIVE-171",
    platFormCode: "PP",
  },
  {
    img: "/assets/casinoList/ppl_indonesian_blackjackx_18.webp",
    platform: "PP",
    name: "Indonesian BlackjackX 18",
    gameType: "LIVE",
    casinoType: "PP-LIVE-172",
    platFormCode: "PP",
  },
  {
    img: "/assets/casinoList/ppl_indonesian_blackjackx_19.webp",
    platform: "PP",
    name: "Indonesian BlackjackX 19",
    gameType: "LIVE",
    casinoType: "PP-LIVE-173",
    platFormCode: "PP",
  },
  {
    img: "/assets/casinoList/ppl_indonesian_blackjackx_20.webp",
    platform: "PP",
    name: "Indonesian BlackjackX 20",
    gameType: "LIVE",
    casinoType: "PP-LIVE-174",
    platFormCode: "PP",
  },
  // {
  //   img: "/assets/casinoList/ppl_blackjack_130.webp",
  //   platform: "PP",
  //   name: "Blackjack 130",
  // },
  // {
  //   img: "/assets/casinoList/ppl_blackjack_127.webp",
  //   platform: "PP",
  //   name: "Blackjack 127",
  // },
  // {
  //   img: "/assets/casinoList/ppl_blackjack_128.webp",
  //   platform: "PP",
  //   name: "Blackjack 128",
  // },
  // {
  //   img: "/assets/casinoList/ppl_blackjack_129.webp",
  //   platform: "PP",
  //   name: "Blackjack 129",
  // },
  // {
  //   img: "/assets/casinoList/ppl_blackjack_131.webp",
  //   platform: "PP",
  //   name: "Blackjack 131",
  // },
  // {
  //   img: "/assets/casinoList/ppl_blackjack_132.webp",
  //   platform: "PP",
  //   name: "Blackjack 132",
  // },
  // {
  //   img: "/assets/casinoList/ppl_blackjack_133.webp",
  //   platform: "PP",
  //   name: "Blackjack 133",
  // },
  // {
  //   img: "/assets/casinoList/ppl_blackjack_134.webp",
  //   platform: "PP",
  //   name: "Blackjack 134",
  // },
  {
    img: "/assets/casinoList/ppl_thai_roulette.webp",
    platform: "PP",
    name: "Thai Roulette",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-178",
  },
  {
    img: "/assets/casinoList/ppl_squeeze_baccarat.webp",
    platform: "PP",
    name: "Squeeze Baccarat",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-179",
  },
  // {
  //   img: "/assets/casinoList/ppl_turbo_baccarat.webp",
  //   platform: "PP",
  //   name: "Turbo Baccarat",
  // },
  // {
  //   img: "/assets/casinoList/ppl_korean_turbo_baccarat_1.webp",
  //   platform: "PP",
  //   name: "Korean Turbo Baccarat 1",
  // },
  {
    img: "/assets/casinoList/ppl_american_roulette.webp",
    platform: "PP",
    name: "American Roulette",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-020",
  },
  // {
  //   img: "/assets/casinoList/ppl_blackjack_117.webp",
  //   platform: "PP",
  //   name: "Blackjack 117",
  // },
  // {
  //   img: "/assets/casinoList/ppl_blackjack_119.webp",
  //   platform: "PP",
  //   name: "Blackjack 119",
  // },
  // {
  //   img: "/assets/casinoList/ppl_blackjack_120.webp",
  //   platform: "PP",
  //   name: "Blackjack 120",
  // },
  // {
  //   img: "/assets/casinoList/ppl_blackjack_115.webp",
  //   platform: "PP",
  //   name: "Blackjack 115",
  // },
  // {
  //   img: "/assets/casinoList/ppl_blackjack_126.webp",
  //   platform: "PP",
  //   name: "Blackjack 126",
  // },
  // {
  //   img: "/assets/casinoList/ppl_blackjack_125.webp",
  //   platform: "PP",
  //   name: "Blackjack 125",
  // },
  // {
  //   img: "/assets/casinoList/ppl_blackjack_124.webp",
  //   platform: "PP",
  //   name: "Blackjack 124",
  // },
  // {
  //   img: "/assets/casinoList/ppl_blackjack_123.webp",
  //   platform: "PP",
  //   name: "Blackjack 123",
  // },
  // {
  //   img: "/assets/casinoList/ppl_blackjack_122.webp",
  //   platform: "PP",
  //   name: "Blackjack 122",
  // },
  // {
  //   img: "/assets/casinoList/ppl_blackjack_121.webp",
  //   platform: "PP",
  //   name: "Blackjack 121",
  // },
  // {
  //   img: "/assets/casinoList/pltl_live_lobby.webp",
  //   platform: "PT",
  //   name: "Live Lobby",
  // },
  {
    img: "/assets/casinoList/pltl_spin_a_win_wild_live.webp",
    platform: "PT",
    name: "Spin A Win Wild Live",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-088",
  },
  {
    img: "/assets/casinoList/pltl_andar_bahar.webp",
    platform: "PT",
    name: "Andar Bahar",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-004",
  },
  {
    img: "/assets/casinoList/pltl_mega_fire_blaze_roulette_live.webp",
    platform: "PT",
    name: "Mega Fire Blaze Roulette Live",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-028",
  },
  {
    img: "/assets/casinoList/pltl_adventures_beyond_wonderland_live.webp",
    platform: "PT",
    name: "Adventures Beyond Wonderland Live",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-011",
  },
  {
    img: "/assets/casinoList/pltl_quantum_roulette_live.webp",
    platform: "PT",
    name: "Quantum Roulette Live",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-067",
  },
  {
    img: "/assets/casinoList/pltl_roulette.webp",
    platform: "PT",
    name: "Roulette",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-001",
  },
  {
    img: "/assets/casinoList/pltl_x1000_quantum_roulette.webp",
    platform: "PT",
    name: "x1000 Quantum Roulette",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-102",
  },
  {
    img: "/assets/casinoList/pltl_spin_a_win.webp",
    platform: "PT",
    name: "Spin a Win",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-015",
  },
  {
    img: "/assets/casinoList/pltl_sic_bo.webp",
    platform: "PT",
    name: "Sic Bo",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-079",
  },
  {
    img: "/assets/casinoList/pltl_the_greatest_cards_show.webp",
    platform: "PT",
    name: "The Greatest Cards Show",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-086",
  },
  {
    img: "/assets/casinoList/pltl_prestige_roulette.webp",
    platform: "PT",
    name: "Prestige Roulette",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-057",
  },
  {
    img: "/assets/casinoList/pltl_arabic_roulette.webp",
    platform: "PT",
    name: "Arabic Roulette",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-078",
  },
  {
    img: "/assets/casinoList/pltl_football_roulette.webp",
    platform: "PT",
    name: "Football Roulette",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-024",
  },
  {
    img: "/assets/casinoList/pltl_grand_baccarat.webp",
    platform: "PT",
    name: "Grand Baccarat",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-034",
  },
  {
    img: "/assets/casinoList/pltl_sicbo_deluxe.webp",
    platform: "PT",
    name: "SicBo Deluxe",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-003",
  },
  {
    img: "/assets/casinoList/pltl_speed_baccarat.webp",
    platform: "PT",
    name: "Speed Baccarat",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-109",
  },
  // {
  //   img: "/assets/casinoList/pltl_ruleta_automtica_cuntica.webp",
  //   platform: "PT",
  //   name: "Ruleta Automática Cuántica",
  // },
  {
    img: "/assets/casinoList/pltl_super_card_blackjack_live.webp",
    platform: "PT",
    name: "Super Card Blackjack Live",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-147",
  },
  // {
  //   img: "/assets/casinoList/pltl_blackjack_2.webp",
  //   platform: "PT",
  //   name: "Blackjack 2",
  // },
  {
    img: "/assets/casinoList/pltl_baccarat_soire_nc.webp",
    platform: "PT",
    name: "Baccarat Soirée No Comission",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-115",
  },
  {
    img: "/assets/casinoList/pltl_baccarat_soire.webp",
    platform: "PT",
    name: "Baccarat Soirée",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-115",
  },
  {
    img: "/assets/casinoList/pltl_punto_banco_soire_gold.webp",
    platform: "PT",
    name: "Punto Banco Soirée Gold",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-125",
  },
  {
    img: "/assets/casinoList/pltl_blackjack_soire_gold_4.webp",
    platform: "PT",
    name: "Blackjack Soirée Gold 4",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-124",
  },
  {
    img: "/assets/casinoList/pltl_blackjack_soire_gold_3.webp",
    platform: "PT",
    name: "Blackjack Soirée Gold 3",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-123",
  },
  {
    img: "/assets/casinoList/pltl_blackjack_soire_gold_2.webp",
    platform: "PT",
    name: "Blackjack Soirée Gold 2",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-122",
  },
  {
    img: "/assets/casinoList/pltl_blackjack_soire_gold_1.webp",
    platform: "PT",
    name: "Blackjack Soirée Gold 1",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-121",
  },
  {
    img: "/assets/casinoList/pltl_cash_collect_roulette_live.webp",
    platform: "PT",
    name: "Cash Collect Roulette Live",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-131",
  },
  {
    img: "/assets/casinoList/pltl_blackjack_soire_4.webp",
    platform: "PT",
    name: "Blackjack Soirée 4",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-124",
  },
  {
    img: "/assets/casinoList/pltl_sticky_bandits_roulette_live.webp",
    platform: "PT",
    name: "Sticky Bandits Roulette Live",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-128",
  },
  {
    img: "/assets/casinoList/pltl_all_bets_blackjack_brasileira.webp",
    platform: "PT",
    name: "All Bets Blackjack Brasileira",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-126",
  },
  {
    img: "/assets/casinoList/pltl_lucky_ball_roulette.webp",
    platform: "PT",
    name: "Lucky Ball Roulette",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-130",
  },
  {
    img: "/assets/casinoList/pltl_emperor_baccarat_nc.webp",
    platform: "PT",
    name: "Emperor Baccarat NC",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-120",
  },
  {
    img: "/assets/casinoList/pltl_emperor_baccarat.webp",
    platform: "PT",
    name: "Emperor Baccarat",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-119",
  },
  {
    img: "/assets/casinoList/pltl_mega_fire_blaze_lucky_ball_live.webp",
    platform: "PT",
    name: "Mega Fire Blaze Lucky Ball Live",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-110",
  },
  {
    img: "/assets/casinoList/pltl_gangnam_speed_baccarat_nc.webp",
    platform: "PT",
    name: "Gangnam Speed Baccarat NC",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-118",
  },
  {
    img: "/assets/casinoList/pltl_gangnam_speed_baccarat.webp",
    platform: "PT",
    name: "Gangnam Speed Baccarat",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-117",
  },
  // {
  //   img: "/assets/casinoList/pltl_jade_baccarat_nc.webp",
  //   platform: "PT",
  //   name: "Jade Baccarat NC",
  // },
  // {
  //   img: "/assets/casinoList/pltl_jade_baccarat.webp",
  //   platform: "PT",
  //   name: "Jade Baccarat",
  // },
  {
    img: "/assets/casinoList/pltl_blackjack_10.webp",
    platform: "PT",
    name: "Blackjack 10",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-127",
  },
  {
    img: "/assets/casinoList/pltl_mega_fire_blaze_lucky_ball_brasileiro.webp",
    platform: "PT",
    name: "Mega Fire Blaze Lucky Ball Brasileiro",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-108",
  },
  {
    img: "/assets/casinoList/pltl_mega_fire_blaze_blackjack_live.webp",
    platform: "PT",
    name: "Mega Fire Blaze Blackjack Live",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-106",
  },
  {
    img: "/assets/casinoList/pltl_quantum_auto_roulette.webp",
    platform: "PT",
    name: "Quantum Auto Roulette",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-026",
  },
  {
    img: "/assets/casinoList/pltl_japanese_squeeze_baccarat_nc.webp",
    platform: "PT",
    name: "Japanese Squeeze Baccarat NC",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-092",
  },
  {
    img: "/assets/casinoList/pltl_japanese_squeeze_baccarat.webp",
    platform: "PT",
    name: "Japanese Squeeze Baccarat",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-091",
  },
  {
    img: "/assets/casinoList/pltl_auto_roulette_2.webp",
    platform: "PT",
    name: "Auto Roulette 2",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-100",
  },
  {
    img: "/assets/casinoList/pltl_royale_blackjack_2_new.webp",
    platform: "PT",
    name: "Royale Blackjack 2",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-052",
  },
  {
    img: "/assets/casinoList/pltl_speed_baccarat_2_nc.webp",
    platform: "PT",
    name: "Baccarat Brasileira",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-097",
  },
  {
    img: "/assets/casinoList/pltl_speed_baccarat_2.webp",
    platform: "PT",
    name: "Baccarat Brasileira",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-097",
  },
  {
    img: "/assets/casinoList/pltl_speed_baccarat_1_nc.webp",
    platform: "PT",
    name: "Speed Baccarat 1 NC",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-144",
  },
  {
    img: "/assets/casinoList/pltl_speed_baccarat_1.webp",
    platform: "PT",
    name: "Speed Baccarat 1",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-159",
  },
  {
    img: "/assets/casinoList/pltl_buffalo_blitz_espana.webp",
    platform: "PT",
    name: "Buffalo Blitz",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-003",
  },
  {
    img: "/assets/casinoList/pltl_speed_6_scanner_baccarat_nc.webp",
    platform: "PT",
    name: "Speed 6 Scanner Baccarat NC",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-038",
  },
  {
    img: "/assets/casinoList/pltl_speed_6_scanner_baccarat.webp",
    platform: "PT",
    name: "Speed 6 Scanner Baccarat",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-035",
  },
  {
    img: "/assets/casinoList/pltl_slingshot_ruleta_espana.webp",
    platform: "PT",
    name: "Slingshot Ruleta España",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-083",
  },
  {
    img: "/assets/casinoList/pltl_ruyi_roulette.webp",
    platform: "PT",
    name: "Ruyi Roulette",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-081",
  },
  {
    img: "/assets/casinoList/pltl_ruyi_french_roulette.webp",
    platform: "PT",
    name: "Ruyi French Roulette",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-080",
  },
  {
    img: "/assets/casinoList/pltl_quantum_ruleta_espana.webp",
    platform: "PT",
    name: "Quantum Ruleta España",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-079",
  },
  {
    img: "/assets/casinoList/pltl_greek_quantum_roulette.webp",
    platform: "PT",
    name: "Greek Quantum Roulette",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-076",
  },
  {
    img: "/assets/casinoList/pltl_bucharest_french_roulette.webp",
    platform: "PT",
    name: "Bucharest French Roulette",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-066",
  },
  {
    img: "/assets/casinoList/pltl_bucharest_roulette.webp",
    platform: "PT",
    name: "Bucharest Roulette",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-063",
  },
  {
    img: "/assets/casinoList/pltl_blackjack_9.webp",
    platform: "PT",
    name: "Blackjack 9",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-068",
  },
  {
    img: "/assets/casinoList/pltl_blackjack_8.webp",
    platform: "PT",
    name: "Blackjack 8",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-074",
  },
  {
    img: "/assets/casinoList/pltl_blackjack_7.webp",
    platform: "PT",
    name: "Blackjack 7",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-073",
  },
  {
    img: "/assets/casinoList/pltl_blackjack_6.webp",
    platform: "PT",
    name: "Blackjack 6",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-072",
  },
  // {
  //   img: "/assets/casinoList/pltl_soire_elite_vip_blackjack_2.webp",
  //   platform: "PT",
  //   name: "Soirée Elite VIP Blackjack 2",
  // },
  {
    img: "/assets/casinoList/pltl_royale_blackjack_3.webp",
    platform: "PT",
    name: "Royale Blackjack 3",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-052",
  },
  // {
  //   img: "/assets/casinoList/pltl_grand_blackjack.webp",
  //   platform: "PT",
  //   name: "Grand Blackjack",
  // },
  {
    img: "/assets/casinoList/pltl_turkish_roulette.webp",
    platform: "PT",
    name: "Turkish Roulette",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-033",
  },
  // {
  //   img: "/assets/casinoList/pltl_triumph_french_roulette.webp",
  //   platform: "PT",
  //   name: "Triumph French Roulette",
  // },
  {
    img: "/assets/casinoList/pltl_spread_bet_roulette.webp",
    platform: "PT",
    name: "Spread Bet Roulette",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-027",
  },
  {
    img: "/assets/casinoList/pltl_slingshot.webp",
    platform: "PT",
    name: "Auto Roulette",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-061",
  },
  {
    img: "/assets/casinoList/pltl_roulette_italiana.webp",
    platform: "PT",
    name: "Roulette Italiana",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-060",
  },
  {
    img: "/assets/casinoList/pltl_roleta_brasileira.webp",
    platform: "PT",
    name: "Roleta Brasileira",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-059",
  },
  {
    img: "/assets/casinoList/pltl_prime_slingshot.webp",
    platform: "PT",
    name: "Speed Auto Roulette",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-212",
  },
  {
    img: "/assets/casinoList/pltl_hindi_roulette.webp",
    platform: "PT",
    name: "Hindi Roulette",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-430",
  },
  {
    img: "/assets/casinoList/pltl_greek_roulette.webp",
    platform: "PT",
    name: "Greek Roulette",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-055",
  },
  {
    img: "/assets/casinoList/pltl_french_roulette.webp",
    platform: "PT",
    name: "French Roulette",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-181",
  },
  {
    img: "/assets/casinoList/pltl_football_french_roulette.webp",
    platform: "PT",
    name: "Football French Roulette",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-023",
  },
  {
    img: "/assets/casinoList/pltl_american_roulette.webp",
    platform: "PT",
    name: "American Roulette",
    platFormCode: "EVOLUTION",
    gameType: "LIVE",
    casinoType: "EVOLUTION-LIVE-020",
  },
  // {
  //   img: "/assets/casinoList/pltl_age_of_the_gods_bonus_roulette.webp",
  //   platform: "PT",
  //   name: "Age of the Gods Bonus Roulette",
  // },
  {
    img: "/assets/casinoList/pltl_bet_on_poker.webp",
    platform: "PT",
    name: "Bet on Poker",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-019",
  },
  // {
  //   img: "/assets/casinoList/pltl_casino_stud_poker.webp",
  //   platform: "PT",
  //   name: "Casino Stud Poker",
  // },
  {
    img: "/assets/casinoList/pltl_casino_holdem.webp",
    platform: "PT",
    name: "Casino Hold’em",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-182",
  },
];

export const Slot = [
  {
    img: "/assets/slot/685b80601c68d.webp",
    platform: "JILI",
    name: "Golden Empire 2",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-143",
  },
  {
    img: "/assets/slot/68746d1c71388.webp",
    platform: "JILI",
    name: "Money Coming 2",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-146",
  },
  {
    img: "/assets/slot/68772bddeb34e.webp",
    platform: "JILI",
    name: "Circus Joker 4096",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-136",
  },
  {
    img: "/assets/slot/6879f6c5b1382.webp",
    platform: "JILI",
    name: "Fortune Gems 500",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-096",
  },
  {
    img: "/assets/slot/68a54a67e5ad6.webp",
    platform: "JILI",
    name: "Sweet Magic",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-150",
  },
  {
    img: "/assets/slot/68b7c210a1bc4.webp",
    platform: "JILI",
    name: "Crystal 777 DELUXE",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-128",
  },
  {
    img: "/assets/slot/68ca63b072266.webp",
    platform: "JILI",
    name: "Rapid Gems 777",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-152",
  },
  {
    img: "/assets/slot/68d3611b5cbe0.webp",
    platform: "JILI",
    name: "Jackpot Joker FEVER",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-153",
  },
  {
    img: "/assets/slot/68dcea7b297cd.webp",
    platform: "JILI",
    name: "Safari King",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-154",
  },
  {
    img: "/assets/slot/68e5e329a3524.webp",
    platform: "JILI",
    name: "ROMA X 10000",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-155",
  },
  {
    img: "/assets/slot/68f848b653ec3.webp",
    platform: "JILI",
    name: "Cash Coin",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-157",
  },
  {
    img: "/assets/slot/690af2bfce7b5.webp",
    platform: "JILI",
    name: "Joker Coins",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-137",
  },
  {
    img: "/assets/slot/691437c3ba2d5.webp",
    platform: "JILI",
    name: "Royal Quest",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-089",
  },
  {
    img: "/assets/slot/691d2e6e634d6.webp",
    platform: "JILI",
    name: "Boxing King Title Match",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-161",
  },
  {
    img: "/assets/slot/692677941d75c.webp",
    platform: "JILI",
    name: "Fortune Coins 2",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-147",
  },
  {
    img: "/assets/slot/692fbf6a664ff.webp",
    platform: "JILI",
    name: "Circus Jackpot",
    platFormCode: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-015",
  },
  {
    img: "/assets/slot/6938dd1fcc9b2.webp",
    platform: "JILI",
    name: "10 Sparkling Crown",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-133",
  },
  {
    img: "/assets/slot/694229b439fc3.webp",
    platform: "JILI",
    name: "Clover Coins 3x3",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-148",
  },
  {
    img: "/assets/slot/694ba12a4136a.webp",
    platform: "JILI",
    name: "Gallina Fortunata",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-083",
  },
  {
    img: "/assets/slot/673dc5075a18a.webp",
    platform: "JILI",
    name: "King Arthur",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-091",
  },
  {
    img: "/assets/slot/6704982c17276.webp",
    platform: "JILI",
    name: "Money Pot",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-112",
  },
  {
    img: "/assets/slot/66bac064120d4.webp",
    platform: "JILI",
    name: "3 Lucky Piggy",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-109",
  },
  {
    img: "/assets/slot/646490e8c2eea.webp",
    platform: "JILI",
    name: "Wild Ace",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-075",
  },
  {
    img: "/assets/slot/6448f47d4aab4.webp",
    platform: "JILI",
    name: "Golden Joker",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-074",
  },
  {
    img: "/assets/slot/683827044f69d.webp",
    platform: "JILI",
    name: "Color Game Extreme",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-078",
  },
  {
    img: "/assets/slot/6836b04d71aed.webp",
    platform: "JILI",
    name: "Golden Treasure",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-077",
  },
  {
    img: "/assets/slot/682edf1ae2060.webp",
    platform: "JILI",
    name: "3 LUCKY LION",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-140",
  },
  {
    img: "/assets/slot/681b27a149ce8.webp",
    platform: "JILI",
    name: "Pirate Queen 2",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-135",
  },
  {
    img: "/assets/slot/680897f96fb28.webp",
    platform: "JILI",
    name: "Penalty Kick",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-072",
  },
  {
    img: "/assets/slot/668955e4c9622.webp",
    platform: "JILI",
    name: "Super Ace Deluxe",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-102",
  },
  {
    img: "/assets/slot/669f794e9a160.webp",
    platform: "JILI",
    name: "Money Coming Expand Bets",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-107",
  },
  {
    img: "/assets/slot/663b93a739b8a.webp",
    platform: "JILI",
    name: "3 Coin Treasures",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-101",
  },
  {
    img: "/assets/slot/661fcc1ccb924.webp",
    platform: "JILI",
    name: "Jackpot Joker",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-100",
  },
  {
    img: "/assets/slot/661f7f896d078.webp",
    platform: "JILI",
    name: "Fortune Gems 3",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-096",
  },
  {
    img: "/assets/slot/6614e786b5ee4.webp",
    platform: "JILI",
    name: "Devil Fire 2",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-094",
  },
  {
    img: "/assets/slot/6614e619e93e9.webp",
    platform: "JILI",
    name: "Zeus",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-097",
  },
  {
    img: "/assets/slot/65e98b2f33832.webp",
    platform: "JILI",
    name: "Trial of Phoenix",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-084",
  },
  {
    img: "/assets/slot/65e0472f924e5.webp",
    platform: "JILI",
    name: "Arena Fighter",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-092",
  },
  {
    img: "/assets/slot/65bb769cda53c.webp",
    platform: "JILI",
    name: "Charge Buffalo Ascent",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-093",
  },
  {
    img: "/assets/slot/659392ea8be92.webp",
    platform: "JILI",
    name: "Night City",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-090",
  },
  {
    img: "/assets/slot/658170c22103f.webp",
    platform: "JILI",
    name: "Sin City",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-089",
  },
  {
    img: "/assets/slot/656da00153274.webp",
    platform: "JILI",
    name: "Dabanggg",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-088",
  },
  {
    img: "/assets/slot/65694afbf35bc.webp",
    platform: "JILI",
    name: "Samba",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-070",
  },
  {
    img: "/assets/slot/65694a3d9a86a.webp",
    platform: "JILI",
    name: "JILI CAISHEN",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-060",
  },
  {
    img: "/assets/slot/6569482b28445.webp",
    platform: "JILI",
    name: "Fortune Bingo",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-015",
  },
  {
    img: "/assets/slot/654d987bed2f7.webp",
    platform: "JILI",
    name: "Bonus Hunter",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-062",
  },
  {
    img: "/assets/slot/654d97d0b8bdc.webp",
    platform: "JILI",
    name: "Super Bingo",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-018",
  },
  {
    img: "/assets/slot/654d975af350c.webp",
    platform: "JILI",
    name: "Pirate Queen",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-073",
  },
  {
    img: "/assets/slot/654b5e1006560.webp",
    platform: "JILI",
    name: "Fortune Monkey",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-087",
  },
  {
    img: "/assets/slot/6538c96113d9e.webp",
    platform: "JILI",
    name: "Aztec Priestess",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-083",
  },
  {
    img: "/assets/slot/652fcfe1bdb05.webp",
    platform: "JILI",
    name: "Bangla Beauty",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-086",
  },
  {
    img: "/assets/slot/6527bc5ee1def.webp",
    platform: "JILI",
    name: "Devil Fire",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-085",
  },
  {
    img: "/assets/slot/65153571babce.webp",
    platform: "JILI",
    name: "Cricket Sah 75",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-082",
  },
  {
    img: "/assets/slot/650c05aaeca2c.webp",
    platform: "JILI",
    name: "Golden Temple",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-080",
  },
  {
    img: "/assets/slot/64ec0e29f2fe6.webp",
    platform: "JILI",
    name: "Elf Bingo",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-081",
  },
  {
    img: "/assets/slot/64d9df81980b0.webp",
    platform: "JILI",
    name: "Cricket King 18",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-078",
  },
  {
    img: "/assets/slot/64c1ef9d1e622.webp",
    platform: "JILI",
    name: "Sweet Land",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-079",
  },
  {
    img: "/assets/slot/64881eb6a43d8.webp",
    platform: "JILI",
    name: "Master Tiger",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-077",
  },
  {
    img: "/assets/slot/63f1d6f128e21.webp",
    platform: "JILI",
    name: "Wild Racer",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-072",
  },
  {
    img: "/assets/slot/6304b3bd854e4.webp",
    platform: "JILI",
    name: "Bone Fortune",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-059",
  },
  {
    img: "/assets/slot/62e27e33b411c.webp",
    platform: "JILI",
    name: "Crazy Pusher",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-054",
  },
  {
    img: "/assets/slot/62de5e8ed509c.webp",
    platform: "JILI",
    name: "Mayan Empire",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-058",
  },
  {
    img: "/assets/slot/137_0.webp",
    platform: "JILI",
    name: "Gold Rush",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-057",
  },
  {
    img: "/assets/slot/116_0.webp",
    platform: "JILI",
    name: "Happy Taxi",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-056",
  },
  {
    img: "/assets/slot/130_0.webp",
    platform: "JILI",
    name: "Thor X",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-052",
  },
  {
    img: "/assets/slot/87_0.webp",
    platform: "JILI",
    name: "Book of Gold",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-053",
  },
  {
    img: "/assets/slot/101_0.webp",
    platform: "JILI",
    name: "Medusa",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-050",
  },
  {
    img: "/assets/slot/89_0.webp",
    platform: "JILI",
    name: "Lucky Lady",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-046",
  },
  {
    img: "/assets/slot/134_0.webp",
    platform: "JILI",
    name: "Mega Ace",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-051",
  },
  {
    img: "/assets/slot/110_0.webp",
    platform: "JILI",
    name: "Ali Baba",
    platFormCode: "TADA",
    gameType: "SLOT",
    casinoType: "TADA-SLOT-030",
  },
  {
    img: "/assets/slot/106_0.webp",
    platform: "JILI",
    name: "TWIN WINS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-047",
  },
  {
    img: "/assets/slot/115_0.webp",
    platform: "JILI",
    name: "Agent Ace",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-048",
  },
  {
    img: "/assets/slot/108_0.webp",
    platform: "JILI",
    name: "Magic Lamp",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-046",
  },
  {
    img: "/assets/slot/76_0.webp",
    platform: "JILI",
    name: "Party Night",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-044",
  },
  {
    img: "/assets/slot/92_0.webp",
    platform: "JILI",
    name: "Crazy Hunter",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-045",
  },
  {
    img: "/assets/slot/109_0.webp",
    platform: "JILI",
    name: "Fortune Gems",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-043",
  },
  {
    img: "/assets/slot/103_0.webp",
    platform: "JILI",
    name: "Golden Empire",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-042",
  },
  {
    img: "/assets/slot/102_0.webp",
    platform: "JILI",
    name: "RomaX",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-040",
  },
  {
    img: "/assets/slot/100_0.webp",
    platform: "JILI",
    name: "Super Rich",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-041",
  },
  {
    img: "/assets/slot/91_0.webp",
    platform: "JILI",
    name: "Lucky Coming",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-037",
  },
  {
    img: "/assets/slot/85_0.webp",
    platform: "JILI",
    name: "Pharaoh Treasure",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-038",
  },
  {
    img: "/assets/slot/78_0.webp",
    platform: "JILI",
    name: "Secret Treasure",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-039",
  },
  {
    img: "/assets/slot/16_0.webp",
    platform: "JILI",
    name: "Jungle King",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-028",
  },
  {
    img: "/assets/slot/58_0.webp",
    platform: "JILI",
    name: "Golden Queen",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-030",
  },

  {
    img: "/assets/slot/pgp_sweet_bonanza.webp",
    platform: "PP",
    name: "Sweet Bonanza",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-082",
  },
  {
    img: "/assets/slot/pgp_master_chens_fortune.webp",
    platform: "PP",
    name: "Master Chen's Fortune",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-097",
  },
  {
    img: "/assets/slot/pgp_gates_of_olympus.webp",
    platform: "PP",
    name: "Gates of Olympus",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-002",
  },
  {
    img: "/assets/slot/pgp_spaceman.webp",
    platform: "PP",
    name: "Spaceman",
    platFormCode: "PP",
    gameType: "EGAME",
    casinoType: "PP-EGAME-001",
  },
  {
    img: "/assets/slot/pgp_sweet_bonanza_xmas.webp",
    platform: "PP",
    name: "Sweet Bonanza Xmas",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-067",
  },
  {
    img: "/assets/slot/pgp_master_joker.webp",
    platform: "PP",
    name: "Master Joker",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-059",
  },
  {
    img: "/assets/slot/pgp_cosmic_cash.webp",
    platform: "PP",
    name: "Cosmic Cash",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-258",
  },
  {
    img: "/assets/slot/pgp_shining_hot_5.webp",
    platform: "PP",
    name: "Shining Hot 5",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-270",
  },
  {
    img: "/assets/slot/pgp_emperor_caishen.webp",
    platform: "PP",
    name: "Emperor Caishen",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-220",
  },
  {
    img: "/assets/slot/pgp_starlight_princess.webp",
    platform: "PP",
    name: "Starlight Princess",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-189",
  },
  {
    img: "/assets/slot/pgp_shining_hot_40.webp",
    platform: "PP",
    name: "Shining Hot 40",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-268",
  },
  {
    img: "/assets/slot/pgp_queen_of_gods.webp",
    platform: "PP",
    name: "Queen of Gods",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-257",
  },
  {
    img: "/assets/slot/pgp_caishens_gold.webp",
    platform: "PP",
    name: "Caishen's Gold",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-121",
  },
  {
    img: "/assets/slot/pgp_extra_juicy.webp",
    platform: "PP",
    name: "Extra Juicy",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-087",
  },
  {
    img: "/assets/slot/pgp_fire_strike.webp",
    platform: "PP",
    name: "Fire Strike",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-069",
  },
  {
    img: "/assets/slot/pgp_big_bass_splash.webp",
    platform: "PP",
    name: "Big Bass Splash",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-261",
  },
  {
    img: "/assets/slot/pgp_fire_88.webp",
    platform: "PP",
    name: "Fire 88",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-109",
  },
  {
    img: "/assets/slot/pgp_amazing_money_machine.webp",
    platform: "PP",
    name: "Amazing Money Machine",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-179",
  },
  {
    img: "/assets/slot/pgp_big_juan.webp",
    platform: "PP",
    name: "Big Juan",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-209",
  },
  {
    img: "/assets/slot/pgp_rise_of_giza_powernudge.webp",
    platform: "PP",
    name: "Rise of Giza PowerNudge",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-186",
  },

  {
    img: "/assets/slot/pgp_captain_kraken_megaways.webp",
    platform: "PP",
    name: "Captain Kraken Megaways",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-594",
  },
  {
    img: "/assets/slot/pgp_spire.webp",
    platform: "PP",
    name: "Spire+",
    platFormCode: "PP",
    gameType: "EGAME",
    casinoType: "PP-EGAME-013",
  },
  {
    img: "/assets/slot/pgp_jackpot_blaze.webp",
    platform: "PP",
    name: "Jackpot Blaze",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-592",
  },
  {
    img: "/assets/slot/pgp_fire_stampede_2.webp",
    platform: "PP",
    name: "Fire Stampede 2",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-591",
  },
  {
    img: "/assets/slot/pgp_zombie_school_megaways.webp",
    platform: "PP",
    name: "Zombie School Megaways",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-590",
  },
  {
    img: "/assets/slot/pgp_spellmaster.webp",
    platform: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-589",
    name: "Spellmaster",
    platFormCode: "PP",
  },
  {
    img: "/assets/slot/pgp_ice_mints.webp",
    platform: "PP",
    name: "Ice Mints",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-588",
  },
  {
    img: "/assets/slot/pgp_big_bass_reel_repeat.webp",
    platform: "PP",
    name: "Big Bass Reel Repeat",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-585",
  },
  {
    img: "/assets/slot/pgp_argonauts.webp",
    platform: "PP",
    name: "Argonauts",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-587",
  },
  {
    img: "/assets/slot/pgp_sweet_bonanza_super_scatter.webp",
    platform: "PP",
    name: "Sweet Bonanza Super Scatter",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-586",
  },
  {
    img: "/assets/slot/pgp_plinko.webp",
    platform: "PP",
    name: "Plinko+",
    platFormCode: "PP",
    gameType: "EGAME",
    casinoType: "PP-EGAME-012",
  },
  {
    img: "/assets/slot/pgp_wolf_gold_4_pack.webp",
    platform: "PP",
    name: "Wolf Gold 4 Pack",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-584",
  },
  {
    img: "/assets/slot/pgp_gem_trio.webp",
    platform: "PP",
    name: "Gem Trio",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-583",
  },
  {
    img: "/assets/slot/pgp_chilli_heat_spicy_spins.webp",
    platform: "PP",
    name: "Chilli Heat Spicy Spins",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-582",
  },
  {
    img: "/assets/slot/pgp_you_can_piggy_bank_on_it.webp",
    platform: "PP",
    name: "You Can Piggy Bank On It",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-581",
  },
  {
    img: "/assets/slot/pgp_alien_invaders.webp",
    platform: "PP",
    name: "Alien Invaders",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-580",
  },
  {
    img: "/assets/slot/pgp_mahjong_wins_super_scatter.webp",
    platform: "PP",
    name: "Mahjong Wins Super Scatter",
    gameType: "SLOT",
    casinoType: "PP-SLOT-372",
    platFormCode: "PP",
  },
  {
    img: "/assets/slot/pgp_club_tropicana__happy_hour.webp",
    platform: "PP",
    name: "Club Tropicana - Happy Hour",
    gameType: "SLOT",
    casinoType: "PP-SLOT-579",
    platFormCode: "PP",
  },
  {
    img: "/assets/slot/pgp_waves_of_poseidon.webp",
    platform: "PP",
    name: "Waves of Poseidon",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-578",
  },
  {
    img: "/assets/slot/pgp_gem_fire_fortune.webp",
    platform: "PP",
    name: "Gem Fire Fortune",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-577",
  },
  {
    img: "/assets/slot/pgp_wild_west_gold_blazing_bounty.webp",
    platform: "PP",
    name: "Wild West Gold Blazing Bounty",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-576",
  },
  {
    img: "/assets/slot/pgp_finger_licking_freespins.webp",
    platform: "PP",
    name: "Finger Lick'n Free Spins",
    gameType: "SLOT",
    casinoType: "PP-SLOT-575",
    platFormCode: "PP",
  },
  {
    img: "/assets/slot/pgp_gold_party_2__after_hours.webp",
    platform: "PP",
    name: "Gold Party 2 - After Hours",
    gameType: "SLOT",
    casinoType: "PP-SLOT-574",
    platFormCode: "PP",
  },
  {
    img: "/assets/slot/pgp_temple_guardians.webp",
    platform: "PP",
    name: "Temple Guardians",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-573",
  },
  {
    img: "/assets/slot/pgp_big_bass_boxing_bonus_round.webp",
    platform: "PP",
    name: "Big Bass Boxing Bonus Round",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-572",
  },
  {
    img: "/assets/slot/pgp_mummys_jewels.webp",
    platform: "PP",
    name: "Mummy's Jewels",
    gameType: "SLOT",
    casinoType: "PP-SLOT-571",
    platFormCode: "PP",
  },
  {
    img: "/assets/slot/pgp_gates_of_hades.webp",
    platform: "PP",
    name: "Gates of Hades",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-569",
  },
  {
    img: "/assets/slot/pgp_eye_of_spartacus.webp",
    platform: "PP",
    name: "Eye of Spartacus",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-570",
  },
  {
    img: "/assets/slot/pgp_gold_rush_2__majestic_express.webp",
    platform: "PP",
    name: "Majestic Express - Gold Run",
    gameType: "SLOT",
    casinoType: "PP-SLOT-568",
    platFormCode: "PP",
  },
  {
    img: "/assets/slot/pgp_resurrecting_riches.webp",
    platform: "PP",
    name: "Resurrecting Riches",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-567",
  },
  {
    img: "/assets/slot/pgp_jumbo_jungle_jackpots.webp",
    platform: "PP",
    name: "Jumbo Safari",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-566",
  },
  {
    img: "/assets/slot/pgp_sleeping_dragon.webp",
    platform: "PP",
    name: "Sleeping Dragon",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-564",
  },
  {
    img: "/assets/slot/pgp_fiesta_fortune.webp",
    platform: "PP",
    name: "Fiesta Fortune",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-565",
  },
  {
    img: "/assets/slot/pgp_witch_heart_megaways.webp",
    platform: "PP",
    name: "Witch Heart Megaways",
    gameType: "SLOT",
    casinoType: "PP-SLOT-563",
    platFormCode: "PP",
  },
  {
    img: "/assets/slot/pgp_gates_of_olympus_super_scatter.webp",
    platform: "PP",
    name: "Gates of Olympus Super Scatter",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-562",
  },
  {
    img: "/assets/slot/pgp_cash_surge.webp",
    platform: "PP",
    name: "Cash Surge",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-561",
  },
  {
    img: "/assets/slot/pgp_big_bass_bonanza_1000.webp",
    platform: "PP",
    name: "Big Bass Bonanza 1000",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-560",
  },
  {
    img: "/assets/slot/pgp_5_lions_reborn.webp",
    platform: "PP",
    name: "5 Lions Reborn",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-559",
  },
  {
    img: "/assets/slot/pgp_ride_the_lightning.webp",
    platform: "PP",
    name: "Ride The Lightning",
    gameType: "SLOT",
    casinoType: "PP-SLOT-558",
    platFormCode: "PP",
  },
  {
    img: "/assets/slot/pgp_jokers_jewels_cash.webp",
    platform: "PP",
    name: "Joker’s Jewels Cash",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-557",
  },
  {
    img: "/assets/slot/pgp_bandit_megaways.webp",
    platform: "PP",
    name: "Bandit Megaways",
  },
  {
    img: "/assets/slot/pgp_blitz_super_wheel.webp",
    platform: "PP",
    name: "Blitz Super Wheel",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-555",
  },
  {
    img: "/assets/slot/pgp_book_of_monsters.webp",
    platform: "PP",
    name: "Book of Monsters",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-554",
  },
  {
    img: "/assets/slot/pgp_triple_pot_gold.webp",
    platform: "PP",
    name: "Triple Pot Gold",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-553",
  },
  {
    img: "/assets/slot/pgp_the_dog_house__royal_hunt.webp",
    platform: "PP",
    name: "The Dog House - Royal Hunt",
    gameType: "SLOT",
    casinoType: "PP-SLOT-552",
    platFormCode: "PP",
  },
  {
    img: "/assets/slot/pgp_volcano_goddess.webp",
    platform: "PP",
    name: "Volcano Goddess",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-551",
  },
  {
    img: "/assets/slot/pgp_luckys_wild_pub.webp",
    platform: "PP",
    name: "Lucky's Wild Pub",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-550",
  },
  {
    img: "/assets/slot/pgp_wild_wild_joker.webp",
    platform: "PP",
    name: "Wild Wild Joker",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-549",
  },
  {
    img: "/assets/slot/pgp_raging_waterfall_megaways.webp",
    platform: "PP",
    name: "Raging Waterfall Megaways",
    gameType: "SLOT",
    casinoType: "PP-SLOT-548",
    platFormCode: "PP",
  },
  {
    img: "/assets/slot/pgp_greedy_fortune_pig.webp",
    platform: "PP",
    name: "Greedy Fortune Pig",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-547",
  },
  {
    img: "/assets/slot/pgp_5_lions_megaways_2.webp",
    platform: "PP",
    name: "5 Lions Megaways 2",
    gameType: "SLOT",
    casinoType: "PP-SLOT-183",
    platFormCode: "PP",
  },
  {
    img: "/assets/slot/pgp_peppes_pepperoni_pizza_plaza.webp",
    platform: "PP",
    name: "Peppe's Pepperoni Pizza Plaza",
    gameType: "SLOT",
    casinoType: "PP-SLOT-545",
    platFormCode: "PP",
  },
  {
    img: "/assets/slot/pgp_big_bass_return_to_the_races.webp",
    platform: "PP",
    name: "Big Bass Return to the Races",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-544",
  },
  {
    img: "/assets/slot/pgp_bigger_bass_splash.webp",
    platform: "PP",
    name: "Bigger Bass Splash",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-543",
  },
  {
    img: "/assets/slot/pgp_savannah_legend.webp",
    platform: "PP",
    name: "Savannah Legend",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-542",
  },
  {
    img: "/assets/slot/pgp_john_hunter_and_galileos_secrets.webp",
    platform: "PP",
    name: "John Hunter and Galileo's Secrets",
    gameType: "SLOT",
    casinoType: "PP-SLOT-541",
    platFormCode: "PP",
  },
  {
    img: "/assets/slot/pgp_ancient_island_megaways.webp",
    platform: "PP",
    name: "Ancient Island Megaways",
    gameType: "SLOT",
    casinoType: "PP-SLOT-540",
    platFormCode: "PP",
  },
  {
    img: "/assets/slot/pgp_lobster_house.webp",
    platform: "PP",
    name: "Lobster House",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-595",
  },
  {
    img: "/assets/slot/pgp_genies_gem_bonanza.webp",
    platform: "PP",
    name: "Genie’s Gem Bonanza",
    gameType: "SLOT",
    casinoType: "PP-SLOT-593",
    platFormCode: "PP",
  },
  {
    img: "/assets/slot/pgp_bee_keeper.webp",
    platform: "PP",
    name: "Bee Keeper",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-596",
  },
  {
    img: "/assets/slot/pgp_bounty_hunter.webp",
    platform: "PP",
    name: "Bounty Hunter",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-597",
  },
  {
    img: "/assets/slot/pgp_bigger_barn_house_bonanza.webp",
    platform: "PP",
    name: "Bigger Barn House Bonanza",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-599",
  },
  {
    img: "/assets/slot/pgp_hundreds_and_thousands.webp",
    platform: "PP",
    name: "Hundreds and Thousands",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-600",
  },
  {
    img: "/assets/slot/pgp_sweet_rush_bonanza.webp",
    platform: "PP",
    name: "Sweet Rush Bonanza",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-601",
  },
  {
    img: "/assets/slot/plt_fire_blaze_blue_wizard_megaways.webp",
    platform: "PT",
    name: "Fire Blaze: Blue Wizard Megaways",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-094",
  },
  {
    img: "/assets/slot/plt_vegas_blackjack.webp",
    platform: "PT",
    name: "Vegas Blackjack",
  },
  {
    img: "/assets/slot/plt_blue_wizard.webp",
    platform: "PT",
    name: "Blue Wizard",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-008",
  },
  {
    img: "/assets/slot/plt_panther_pays.webp",
    platform: "PT",
    name: "Panther Pays",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-230",
  },
  {
    img: "/assets/slot/plt_zhao_cai_jin_bao.webp",
    platform: "PT",
    name: "Zhao Cai Jin Bao",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-012",
  },
  {
    img: "/assets/slot/plt_silver_bullet_bandit_cash_collect.webp",
    platform: "PT",
    name: "Silver Bullet Bandit: Cash Collect",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-107",
  },
  {
    img: "/assets/slot/plt_sky_queen.webp",
    platform: "PT",
    name: "Sky Queen",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-007",
  },
  {
    img: "/assets/slot/plt_diamond_rise.webp",
    platform: "PT",
    name: "Diamond Rise",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-088",
  },
  {
    img: "/assets/slot/plt_zhao_cai_tong_zi.webp",
    platform: "PT",
    name: "Zhao Cai Tong Zi",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-014",
  },
  {
    img: "/assets/slot/plt_mega_fire_blaze_big_circus.webp",
    platform: "PT",
    name: "Mega Fire Blaze: Big Circus!",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-092",
  },
  {
    img: "/assets/slot/plt_mega_fire_blaze_khonsu_god_of_moon.webp",
    platform: "PT",
    name: "Mega Fire Blaze: Khonsu God of Moon",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-153",
  },
  {
    img: "/assets/slot/plt_koi_harmony.webp",
    platform: "PT",
    name: "Koi Harmony",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-106",
  },
  {
    img: "/assets/slot/plt_mega_fire_blaze_wild_pistolero.webp",
    platform: "PT",
    name: "Mega Fire Blaze: Wild Pistolero",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-091",
  },
  {
    img: "/assets/slot/plt_fire_blaze_golden_tundra_wolf.webp",
    platform: "PT",
    name: "Fire Blaze Golden: Tundra Wolf",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-157",
  },
  {
    img: "/assets/slot/plt_golden_macaque.webp",
    platform: "PT",
    name: "Golden Macaque",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-026",
  },
  {
    img: "/assets/slot/plt_eternal_lady.webp",
    platform: "PT",
    name: "Eternal Lady",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-025",
  },
  {
    img: "/assets/slot/plt_leprechauns_luck_cash_collect.webp",
    platform: "PT",
    name: "Leprechaun’s Luck: Cash Collect",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-090",
  },
  {
    img: "/assets/slot/plt_lucky_emeralds.webp",
    platform: "PT",
    name: "Lucky Emeralds",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-216",
  },
  {
    img: "/assets/slot/plt_hit_bar.webp",
    platform: "PT",
    name: "Hit Bar™",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-087",
  },
  {
    img: "/assets/slot/plt_immortal_ways_volcano.webp",
    platform: "PT",
    name: "Immortal Ways Volcano",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-446",
  },
  {
    img: "/assets/slot/plt_flip_royale.webp",
    platform: "PT",
    name: "Flip Royale",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-448",
  },
  {
    img: "/assets/slot/plt_ten_ton_ways_stampede.webp",
    platform: "PT",
    name: "Ten Ton Ways Stampede",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-445",
  },
  {
    img: "/assets/slot/plt_cash_truck_begins.webp",
    platform: "PT",
    name: "Cash Truck Begins",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-444",
  },
  {
    img: "/assets/slot/plt_giga_match_egypt.webp",
    platform: "PT",
    name: "Giga Match Egypt",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-447",
  },
  {
    img: "/assets/slot/plt_solar_eclipse_desert_treasure.webp",
    platform: "PT",
    name: "Solar Eclipse: Desert Treasure",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-066",
  },
  {
    img: "/assets/slot/plt_joker_spin__roll.webp",
    platform: "PT",
    name: "Joker Spin & Roll",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-443",
  },
  {
    img: "/assets/slot/plt_shields_of_lambda.webp",
    platform: "PT",
    name: "Shields of Lambda",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-441",
  },
  {
    img: "/assets/slot/plt_gold_trio_lil_demon.webp",
    platform: "PT",
    name: "Gold Trio: Lil Demon",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-442",
  },
  {
    img: "/assets/slot/plt_gold_hit_oreillys_charms.webp",
    platform: "PT",
    name: "Gold Hit: O'Reilly's Charms",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-076",
  },
  // {
  //   img: "/assets/slot/plt_age_of_the_gods_god_of_storms_fire_blaze.webp",
  //   platform: "PT",
  //   name: "Age of the Gods: God of Storms Fire Blaze",
  // },
  // {
  //   img: "/assets/slot/plt_full_moon_white_panda_powerplay_jackpot.webp",
  //   platform: "PT",
  //   name: "Full Moon: White Panda PowerPlay Jackpot",
  // },
  // {
  //   img: "/assets/slot/plt_bulls_eye_bandits.webp",
  //   platform: "PT",
  //   name: "Bulls Eye Bandits",
  // },
  {
    img: "/assets/slot/plt_gold_trio_leprechauns_luck_bf.webp",
    platform: "PT",
    name: "Gold Trio: Leprechaun's Luck BF",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-416",
  },
  {
    img: "/assets/slot/plt_el_ranchero_cash_collect_diamond_path.webp",
    platform: "PT",
    name: "El Ranchero Cash Collect: Diamond Path",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-415",
  },
  {
    img: "/assets/slot/plt_streak_of_luck_double_dice.webp",
    platform: "PT",
    name: "Streak of Luck: Double Dice",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-411",
  },
  {
    img: "/assets/slot/plt_piggies_and_the_bank_cash_collect__link.webp",
    platform: "PT",
    name: "Piggies and the Bank: Cash Collect & Link",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-412",
  },
  {
    img: "/assets/slot/plt_lil_sphinx.webp",
    platform: "PT",
    name: "Lil Sphinx",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-413",
  },
  // {
  //   img: "/assets/slot/plt_aztec_fruits.webp",
  //   platform: "PT",
  //   name: "Aztec Fruits",
  // },
  {
    img: "/assets/slot/plt_drop_for_top.webp",
    platform: "PT",
    name: "Drop for Top",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-417",
  },
  {
    img: "/assets/slot/plt_reaction_link.webp",
    platform: "PT",
    name: "Reaction Link",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-414",
  },
  {
    img: "/assets/slot/plt_wild_roll.webp",
    platform: "PT",
    name: "Wild Roll",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-419",
  },
  {
    img: "/assets/slot/plt_mini_roulette.webp",
    platform: "PT",
    name: "Mini Roulette",
    platFormCode: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-008",
  },
  {
    img: "/assets/slot/plt_spin_a_win.webp",
    platform: "PT",
    name: "Spin a Win",
    platFormCode: "PT",
    gameType: "LIVE",
    casinoType: "PT-LIVE-015",
  },
  // {
  //   img: "/assets/slot/plt_roulette_mini.webp",
  //   platform: "PT",
  //   name: "Roulette Mini",
  // },
  // {
  //   img: "/assets/slot/plt_azteca_bonus_lines_powerplay_jackpot.webp",
  //   platform: "PT",
  //   name: "Azteca: Bonus Lines PowerPlay Jackpot",
  // },
  // {
  //   img: "/assets/slot/plt_lunar_link_phoenix_moons.webp",
  //   platform: "PT",
  //   name: "Lunar Link: Phoenix Moons",
  // },
  {
    img: "/assets/slot/plt_honey_gems.webp",
    platform: "PT",
    name: "Honey Gems",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-261",
  },
  {
    img: "/assets/slot/plt_devil_wilds.webp",
    platform: "PT",
    name: "Devil Wilds",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-262",
  },
  {
    img: "/assets/slot/plt_pyramid_linx.webp",
    platform: "PT",
    name: "Pyramid Linx",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-418",
  },
  // {
  //   img: "/assets/slot/plt_tiger_turtle_dragon_phoenix.webp",
  //   platform: "PT",
  //   name: "Tiger Turtle Dragon Phoenix",
  // },
  // {
  //   img: "/assets/slot/plt_the_great_genie.webp",
  //   platform: "PT",
  //   name: "The Great Genie",
  // },
  // {
  //   img: "/assets/slot/plt_mega_fire_blaze_3_wizards.webp",
  //   platform: "PT",
  //   name: "Mega Fire Blaze: 3 Wizards",
  // },
  // {
  //   img: "/assets/slot/plt_lucky_gift_cash_collect.webp",
  //   platform: "PT",
  //   name: "Lucky Gift: Cash Collect",
  // },
  {
    img: "/assets/slot/plt_goood_heavens.webp",
    platform: "PT",
    name: "Goood Heavens",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-409",
  },
  {
    img: "/assets/slot/plt_fluffy_favourites_cash_collect.webp",
    platform: "PT",
    name: "Fluffy Favourites: Cash Collect",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-410",
  },
  {
    img: "/assets/slot/plt_tree_wishes.webp",
    platform: "PT",
    name: "Tree Wishes",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-407",
  },
  {
    img: "/assets/slot/plt_lights_of_luck.webp",
    platform: "PT",
    name: "Lights of Luck",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-408",
  },
  {
    img: "/assets/slot/plt_sweet_n_juicy.webp",
    platform: "PT",
    name: "Sweet n' Juicy",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-356",
  },
  {
    img: "/assets/slot/plt_full_moon_white_king.webp",
    platform: "PT",
    name: "Full Moon: White King",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-359",
  },
  {
    img: "/assets/slot/plt_lucky_bass_mega_cash_collect.webp",
    platform: "PT",
    name: "Lucky Bass: Mega Cash Collect",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-358",
  },
  {
    img: "/assets/slot/plt_gold_hit__link_tiger_jones.webp",
    platform: "PT",
    name: "Gold Hit & Link: Tiger Jones",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-357",
  },
  // {
  //   img: "/assets/slot/plt_go_joker_go.webp",
  //   platform: "PT",
  //   name: "Go Joker Go",
  // },
  // {
  //   img: "/assets/slot/plt_link_nile_moon.webp",
  //   platform: "PT",
  //   name: "Link: Nile Moon",
  // },
  // {
  //   img: "/assets/slot/plt_fruit_harvest.webp",
  //   platform: "PT",
  //   name: "Fruit Harvest",
  // },
  // {
  //   img: "/assets/slot/plt_macabra_linx_powerplay_jackpot.webp",
  //   platform: "PT",
  //   name: "Macabra Linx: Powerplay Jackpot",
  // },
  {
    img: "/assets/slot/plt_diamond_match_deluxe.webp",
    platform: "PT",
    name: "Diamond Match Deluxe",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-360",
  },
  // {
  //   img: "/assets/slot/plt_quad_link_red.webp",
  //   platform: "PT",
  //   name: "Quad Link Red",
  // },
  // {
  //   img: "/assets/slot/plt_roman_fruits.webp",
  //   platform: "PT",
  //   name: "Roman Fruits",
  // },
  {
    img: "/assets/slot/plt_lil_demon_mega_cash_collect.webp",
    platform: "PT",
    name: "Lil Demon: Mega Cash Collect",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-361",
  },
  {
    img: "/assets/slot/plt_circuit_shock.webp",
    platform: "PT",
    name: "Circuit Shock",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-352",
  },
  {
    img: "/assets/slot/plt_breach_the_vault.webp",
    platform: "PT",
    name: "Breach The Vault",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-354",
  },
  {
    img: "/assets/slot/plt_candy_roll.webp",
    platform: "PT",
    name: "Candy Roll",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-351",
  },
  {
    img: "/assets/slot/plt_wolves_cash_collect__link.webp",
    platform: "PT",
    name: "Wolves! Cash Collect & Link",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-350",
  },
  {
    img: "/assets/slot/plt_elephant_riches.webp",
    platform: "PT",
    name: "Elephant Riches",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-349",
  },
  {
    img: "/assets/slot/plt_xtreme_fire_blaze_roulette.webp",
    platform: "PT",
    name: "Xtreme Fire Blaze Roulette",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-353",
  },
  {
    img: "/assets/slot/plt_feng_shui_flip.webp",
    platform: "PT",
    name: "Feng Shui Flip",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-348",
  },
  {
    img: "/assets/slot/plt_gold_trio_football.webp",
    platform: "PT",
    name: "Gold Trio: Football",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-347",
  },
  {
    img: "/assets/slot/plt_samurai_fury.webp",
    platform: "PT",
    name: "Samurai Fury",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-346",
  },
  {
    img: "/assets/slot/plt_fire_blaze_sky_queen_megaways.webp",
    platform: "PT",
    name: "Fire Blaze: Sky Queen Megaways",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-345",
  },
  {
    img: "/assets/slot/plt_mega_fire_blaze_dwarves_and_goblins.webp",
    platform: "PT",
    name: "Mega Fire Blaze: Dwarves and Goblins",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-343",
  },
  {
    img: "/assets/slot/plt_panther_moon_bonus_lines.webp",
    platform: "PT",
    name: "Panther Moon: Bonus Lines",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-344",
  },
  {
    img: "/assets/slot/plt_veils_of_venice.webp",
    platform: "PT",
    name: "Veils of Venice",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-321",
  },
  {
    img: "/assets/slot/plt_leprechauns_luck__cash_collect_megaways.webp",
    platform: "PT",
    name: "Leprechaun’s Luck - Cash Collect Megaways",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-090",
  },
  {
    img: "/assets/slot/plt_oink_oink_oink.webp",
    platform: "PT",
    name: "Oink Oink Oink",
    platFormCode: "PT",
    gameType: "SLOT",
    casinoType: "PT-SLOT-319",
  },
  {
    img: "/assets/slot/ntn_gonzos_quest.webp",
    platform: "NETENT",
    name: "Gonzo's Quest",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-009",
  },
  {
    img: "/assets/slot/ntn_turn_your_fortune.webp",
    platform: "NETENT",
    name: "Turn Your Fortune",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-036",
  },
  {
    img: "/assets/slot/ntn_codex_of_fortune.webp",
    platform: "NETENT",
    name: "Codex of Fortune",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-056",
  },
  {
    img: "/assets/slot/ntn_bee_hive_bonanza.webp",
    platform: "NETENT",
    name: "Bee Hive Bonanza",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-128",
  },
  {
    img: "/assets/slot/ntn_wild_water.webp",
    platform: "NETENT",
    name: "Wild Water",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-011",
  },
  // {
  //   img: "/assets/slot/ntn_fruit_blaze.webp",
  //   platform: "NETENT",
  //   name: "Fruit Blaze",
  // },
  {
    img: "/assets/slot/ntn_wild_worlds.webp",
    platform: "NETENT",
    name: "Wild Worlds",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-068",
  },
  {
    img: "/assets/slot/ntn_divine_fortune_megaways.webp",
    platform: "NETENT",
    name: "Divine Fortune Megaways",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-014",
  },
  {
    img: "/assets/slot/ntn_knight_rider.webp",
    platform: "NETENT",
    name: "Knight Rider",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-121",
  },
  {
    img: "/assets/slot/ntn_funk_master.webp",
    platform: "NETENT",
    name: "Funk Master",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-126",
  },
  {
    img: "/assets/slot/ntn_dazzle_me.webp",
    platform: "NETENT",
    name: "Dazzle Me",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-024",
  },
  {
    img: "/assets/slot/ntn_wild_wild_west_the_great_train_heist.webp",
    platform: "NETENT",
    name: "Wild Wild West: The Great Train Heist",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-027",
  },
  {
    img: "/assets/slot/ntn_secret_of_the_stones.webp",
    platform: "NETENT",
    name: "Secret of the Stones",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-063",
  },
  {
    img: "/assets/slot/ntn_vikings_video_slot.webp",
    platform: "NETENT",
    name: "Vikings Video Slot",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-078",
  },
  {
    img: "/assets/slot/ntn_fruit_spin.webp",
    platform: "NETENT",
    name: "Fruit Spin",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-062",
  },
  {
    img: "/assets/slot/ntn_twin_spin_megaways.webp",
    platform: "NETENT",
    name: "Twin Spin Megaways",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-136",
  },
  {
    img: "/assets/slot/ntn_pyramid_quest_for_immortality.webp",
    platform: "NETENT",
    name: "Pyramid: Quest for Immortality",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-030",
  },
  {
    img: "/assets/slot/ntn_rome_the_golden_age.webp",
    platform: "NETENT",
    name: "Rome: The Golden Age",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-012",
  },
  {
    img: "/assets/slot/ntn_warlords_crystals_of_power.webp",
    platform: "NETENT",
    name: "Warlords: Crystals of Power",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-061",
  },
  {
    img: "/assets/slot/ntn_blackjack_classic.webp",
    platform: "NETENT",
    name: "Blackjack Classic",
    platFormCode: "NETENT",
    gameType: "TABLE",
    casinoType: "NETENT-TABLE-001",
  },
  {
    img: "/assets/slot/ntn_piggy_riches_3_hog_heaven.webp",
    platform: "NETENT",
    name: "Piggy Riches 3: Hog Heaven",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-231",
  },
  {
    img: "/assets/slot/ntn_reel_rush_xxxtreme.webp",
    platform: "NETENT",
    name: "Reel Rush XXXtreme",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-229",
  },
  {
    img: "/assets/slot/ntn_jack_hammer_4_chasing_the_dragon.webp",
    platform: "NETENT",
    name: "Jack Hammer 4: Chasing the Dragon",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-228",
  },
  {
    img: "/assets/slot/ntn_divine_fortune_black.webp",
    platform: "NETENT",
    name: "Divine Fortune Black",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-230",
  },
  {
    img: "/assets/slot/ntn_golden_egg_invaders.webp",
    platform: "NETENT",
    name: "Golden Egg Invaders",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-227",
  },
  {
    img: "/assets/slot/ntn_finn_and_the_dragon_tales.webp",
    platform: "NETENT",
    name: "Finn and the Dragon Tales",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-226",
  },
  {
    img: "/assets/slot/ntn_wild_mining_xxxtreme.webp",
    platform: "NETENT",
    name: "Wild Mining XXXtreme",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-225",
  },
  {
    img: "/assets/slot/ntn_gonzos_quest_ii_return_to_el_dorado.webp",
    platform: "NETENT",
    name: "Gonzo's Quest II: Return to El Dorado",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-233",
  },
  {
    img: "/assets/slot/ntn_dead_west.webp",
    platform: "NETENT",
    name: "Dead West",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-232",
  },
  {
    img: "/assets/slot/ntn_rabid_randy_dark_trails.webp",
    platform: "NETENT",
    name: "Rabid Randy Dark Trails",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-234",
  },
  // {
  //   img: "/assets/slot/ntn_flock_me.webp",
  //   platform: "NETENT",
  //   name: "Flock Me",
  // },
  // {
  //   img: "/assets/slot/ntn_dazzle_me_christmas.webp",
  //   platform: "NETENT",
  //   name: "Dazzle Me Christmas",
  // },
  {
    img: "/assets/slot/ntn_mummy_megaways.webp",
    platform: "NETENT",
    name: "Mummy Megaways",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-219",
  },
  {
    img: "/assets/slot/ntn_starburst_galaxy.webp",
    platform: "NETENT",
    name: "Starburst Galaxy",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-220",
  },
  {
    img: "/assets/slot/ntn_mine_blown.webp",
    platform: "NETENT",
    name: "Mine Blown",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-218",
  },
  {
    img: "/assets/slot/ntn_ms_robin_hood.webp",
    platform: "NETENT",
    name: "Ms Robin Hood",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-217",
  },
  {
    img: "/assets/slot/ntn_rabid_randy.webp",
    platform: "NETENT",
    name: "Rabid Randy",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-216",
  },
  {
    img: "/assets/slot/ntn_dragons_playground.webp",
    platform: "NETENT",
    name: "Dragons Playground",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-222",
  },
  {
    img: "/assets/slot/ntn_french_roulette.webp",
    platform: "NETENT",
    name: "French Roulette",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-181",
  },
  {
    img: "/assets/slot/ntn_european_roulette.webp",
    platform: "NETENT",
    name: "European Roulette",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-053",
  },
  {
    img: "/assets/slot/ntn_baccarat.webp",
    platform: "NETENT",
    name: "Baccarat",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-014",
  },
  {
    img: "/assets/slot/ntn_american_roulette.webp",
    platform: "NETENT",
    name: "American Roulette",
    platFormCode: "PP",
    gameType: "LIVE",
    casinoType: "PP-LIVE-176",
  },
  {
    img: "/assets/slot/ntn_excalibur.webp",
    platform: "NETENT",
    name: "Excalibur",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-100",
  },
  {
    img: "/assets/slot/ntn_jacks_or_better_double_up.webp",
    platform: "NETENT",
    name: "Jacks or Better Double Up",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-099",
  },
  {
    img: "/assets/slot/ntn_oceans_treasure.webp",
    platform: "NETENT",
    name: "Ocean's Treasure",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-098",
  },
  {
    img: "/assets/slot/ntn_druids_dream.webp",
    platform: "NETENT",
    name: "Druids' Dream",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-097",
  },
  {
    img: "/assets/slot/ntn_disco_danny.webp",
    platform: "NETENT",
    name: "Disco Danny",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-096",
  },
  {
    img: "/assets/slot/ntn_cash_noire.webp",
    platform: "NETENT",
    name: "Cash Noire",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-095",
  },
  {
    img: "/assets/slot/ntn_grand_spinn.webp",
    platform: "NETENT",
    name: "Grand Spinn",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-094",
  },
  {
    img: "/assets/slot/ntn_halloween_jack.webp",
    platform: "NETENT",
    name: "Halloween Jack",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-093",
  },
  {
    img: "/assets/slot/ntn_cashomatic.webp",
    platform: "NETENT",
    name: "Cash-o-Matic",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-092",
  },
  {
    img: "/assets/slot/ntn_fairytale_legends_mirror_mirror.webp",
    platform: "NETENT",
    name: "Fairytale Legends: Mirror Mirror",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-071",
  },
  {
    img: "/assets/slot/ntn_eggomatic.webp",
    platform: "NETENT",
    name: "EggOMatic",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-090",
  },
  {
    img: "/assets/slot/ntn_mythic_maiden.webp",
    platform: "NETENT",
    name: "Mythic Maiden",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-089",
  },
  {
    img: "/assets/slot/ntn_casino_holdem.webp",
    platform: "NETENT",
    name: "Casino Hold'em",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-088",
  },
  {
    img: "/assets/slot/ntn_dracula.webp",
    platform: "NETENT",
    name: "Dracula",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-002",
  },
  {
    img: "/assets/slot/ntn_fairytale_legends_hansel_and_gretel.webp",
    platform: "NETENT",
    name: "Fairytale Legends: Hansel and Gretel",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-087",
  },
  {
    img: "/assets/slot/ntn_football_champions_cup.webp",
    platform: "NETENT",
    name: "Football: Champions Cup",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-086",
  },
  {
    img: "/assets/slot/ntn_magic_maid_cafe.webp",
    platform: "NETENT",
    name: "Magic Maid Cafe",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-108",
  },
  {
    img: "/assets/slot/ntn_lights.webp",
    platform: "NETENT",
    name: "Lights",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-107",
  },
  {
    img: "/assets/slot/ntn_rise_of_maya.webp",
    platform: "NETENT",
    name: "Rise of Maya",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-106",
  },
  {
    img: "/assets/slot/ntn_the_legend_of_shangrila_cluster_pays.webp",
    platform: "NETENT",
    name: "The Legend of Shangri-La: Cluster Pays",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-105",
  },
  {
    img: "/assets/slot/ntn_spiata_grande.webp",
    platform: "NETENT",
    name: "Spiñata Grande",
    platFormCode: "NETENT",
    gameType: "SLOT",
    casinoType: "NETENT-SLOT-104",
  },
  {
    img: "/assets/slot/jdb_piggy_bank_taptap.webp",
    platform: "JDB",
    name: "Piggy Bank TapTap",
    platFormCode: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-023",
  },
  {
    img: "/assets/slot/jdb_lucky_elephant_xhuge.webp",
    platform: "JDB",
    name: "Lucky Elephant X-Huge",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-135",
  },
  {
    img: "/assets/slot/jdb_olympig.webp",
    platform: "JDB",
    name: "Olympig",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-134",
  },
  {
    img: "/assets/slot/jdb_ragnarok_thor_vs_loki.webp",
    platform: "JDB",
    name: "Ragnarok: Thor vs Loki",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-133",
  },
  {
    img: "/assets/slot/jdb_koi_trio.webp",
    platform: "JDB",
    name: "Koi Trio",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-132",
  },
  {
    img: "/assets/slot/jdb_fishin_fever_xhuge.webp",
    platform: "JDB",
    name: "Fishin' Fever X-Huge",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-131",
  },
  {
    img: "/assets/slot/jdb_open_sesame_ii.webp",
    platform: "JDB",
    name: "Open Sesame II",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-051",
  },
  {
    img: "/assets/slot/jdb_plinko.webp",
    platform: "JDB",
    name: "Plinko",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-041",
  },
  {
    img: "/assets/slot/jdb_piggy_bank.webp",
    platform: "JDB",
    name: "Piggy Bank",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-123",
  },
  {
    img: "/assets/slot/jdb_open_sesame_mega.webp",
    platform: "JDB",
    name: "Open Sesame Mega",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-119",
  },
  {
    img: "/assets/slot/jdb_mines_2.webp",
    platform: "JDB",
    name: "Mines 2",
    platFormCode: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-019",
  },
  {
    img: "/assets/slot/jdb_magic_ace.webp",
    platform: "JDB",
    name: "Magic Ace",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-124",
  },
  {
    img: "/assets/slot/jdb_magic_ace_wild_lock.webp",
    platform: "JDB",
    name: "Magic Ace Wild Lock",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-127",
  },
  {
    img: "/assets/slot/jdb_fortune_horse.webp",
    platform: "JDB",
    name: "Fortune Horse",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-053",
  },
  {
    img: "/assets/slot/jdb_dice.webp",
    platform: "JDB",
    name: "Dice",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-033",
  },
  {
    img: "/assets/slot/jdb_dragon_soar__hyper_wild.webp",
    platform: "JDB",
    name: "Dragon Soar - Hyper Wild",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-125",
  },
  {
    img: "/assets/slot/jdb_pop_pop_candy_1000.webp",
    platform: "JDB",
    name: "Pop Pop Candy 1000",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-129",
  },
  {
    img: "/assets/slot/jdb_fruity_bonanza_combo.webp",
    platform: "JDB",
    name: "Fruity Bonanza Combo",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-130",
  },
  {
    img: "/assets/slot/jdb_caishen_party.webp",
    platform: "JDB",
    name: "CaiShen Party",
    platFormCode: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-005",
  },
  {
    img: "/assets/slot/jdb_fortune_jewel.webp",
    platform: "JDB",
    name: "Fortune Jewel",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-128",
  },
  {
    img: "/assets/slot/jdb_wild_lock.webp",
    platform: "JDB",
    name: "Wild Lock",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-127",
  },
  {
    img: "/assets/slot/jdb_bull_treasure.webp",
    platform: "JDB",
    name: "Bull Treasure",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-126",
  },
  {
    img: "/assets/slot/jdb_jogo_do_bicho.webp",
    platform: "JDB",
    name: "Jogo Do Bicho",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-052",
  },
  {
    img: "/assets/slot/jdb_fruity_bonanza.webp",
    platform: "JDB",
    name: "Fruity Bonanza",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-114",
  },
  {
    img: "/assets/slot/jdb_hilo.webp",
    platform: "JDB",
    name: "HiLo",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-032",
  },
  {
    img: "/assets/slot/jdb_goal.webp",
    platform: "JDB",
    name: "Goal",
    platFormCode: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-015",
  },
  {
    img: "/assets/slot/jdb_firework_burst.webp",
    platform: "JDB",
    name: "Firework Burst",
    platFormCode: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-014",
  },
  {
    img: "/assets/slot/jdb_mines.webp",
    platform: "JDB",
    name: "Mines",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-033",
  },
  {
    img: "/assets/slot/jdb_galaxy_burst.webp",
    platform: "JDB",
    name: "Galaxy Burst",
    platFormCode: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-012",
  },
  {
    img: "/assets/slot/jdb_caishen_coming.webp",
    platform: "JDB",
    name: "CaiShen Coming",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-113",
  },
  // {
  //   img: "/assets/slot/jdb_happy_lottery.webp",
  //   platform: "JDB",
  //   name: "Happy Lottery",
  // },
  // {
  //   img: "/assets/slot/jdb_gold_rooster_lottery.webp",
  //   platform: "JDB",
  //   name: "Gold Rooster Lottery",
  // },
  {
    img: "/assets/slot/jdb_cai_shen_bingo.webp",
    platform: "JDB",
    name: "Cai Shen Bingo",
    platFormCode: "YESBINGO",
    gameType: "BINGO",
    casinoType: "YesBingo-BINGO-001",
  },
  {
    img: "/assets/slot/jdb_lucky_color_game.webp",
    platform: "JDB",
    name: "Lucky Color Game",
    platFormCode: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-002",
  },
  {
    img: "/assets/slot/jdb_king_of_football.webp",
    platform: "JDB",
    name: "King Of Football",
    platFormCode: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-006",
  },
  {
    img: "/assets/slot/jdb_crazy_king_kong.webp",
    platform: "JDB",
    name: "Crazy King Kong",
    platFormCode: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-001",
  },
  {
    img: "/assets/slot/jdb_huaguoshan_legends.webp",
    platform: "JDB",
    name: "Huaguoshan Legends",
    platFormCode: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-008",
  },
  {
    img: "/assets/slot/jdb_beer_tycoon.webp",
    platform: "JDB",
    name: "Beer Tycoon",
    platFormCode: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-010",
  },
  {
    img: "/assets/slot/jdb_birds_and_animals.webp",
    platform: "JDB",
    name: "Birds and Animals",
    platFormCode: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-003",
  },
  {
    img: "/assets/slot/jdb_happy_new_year.webp",
    platform: "JDB",
    name: "Happy New Year",
    platFormCode: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-004",
  },
  {
    img: "/assets/slot/jdb_classic_mario.webp",
    platform: "JDB",
    name: "Classic Mario",
    platFormCode: "JDB",
    gameType: "EGAME",
    casinoType: "JDB-EGAME-009",
  },
  {
    img: "/assets/slot/jdb_coocoo_farm.webp",
    platform: "JDB",
    name: "CooCoo Farm",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-112",
  },
  {
    img: "/assets/slot/pgs_lucky_neko.webp",
    platform: "PG",
    name: "Lucky Neko",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-065",
  },
  {
    img: "/assets/slot/pgs_treasures_of_aztec.webp",
    platform: "PG",
    name: "Treasures of Aztec",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-058",
  },
  {
    img: "/assets/slot/pgs_the_great_icescape.webp",
    platform: "PG",
    name: "The Great Icescape",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-032",
  },
  {
    img: "/assets/slot/pgs_ganesha_fortune.webp",
    platform: "PG",
    name: "Ganesha Fortune",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-052",
  },
  {
    img: "/assets/slot/pgs_mahjong_ways.webp",
    platform: "PG",
    name: "Mahjong Ways",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-041",
  },
  {
    img: "/assets/slot/pgs_wild_bounty_showdown.webp",
    platform: "PG",
    name: "Wild Bounty Showdown",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-105",
  },
  {
    img: "/assets/slot/pgs_speed_winner.webp",
    platform: "PG",
    name: "Speed Winner",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-102",
  },
  {
    img: "/assets/slot/pgs_prosperity_fortune_tree.webp",
    platform: "PG",
    name: "Prosperity Fortune Tree",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-106",
  },
  {
    img: "/assets/slot/pgs_supermarket_spree.webp",
    platform: "PG",
    name: "Supermarket Spree",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-084",
  },
  // {
  //   img: "/assets/slot/pgs_dreams_of_macau.webp",
  //   platform: "PG",
  //   name: "Dreams of Macau",
  // },
  {
    img: "/assets/slot/pgs_mahjong_ways_2.webp",
    platform: "PG",
    name: "Mahjong Ways 2",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-050",
  },
  {
    img: "/assets/slot/pgs_wild_bandito.webp",
    platform: "PG",
    name: "Wild Bandito",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-075",
  },
  {
    img: "/assets/slot/pgs_caishen_wins.webp",
    platform: "PG",
    name: "Caishen Wins",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-047",
  },
  {
    img: "/assets/slot/pgs_ways_of_the_qilin.webp",
    platform: "PG",
    name: "Ways of the Qilin",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-076",
  },
  {
    img: "/assets/slot/pgs_cocktail_nights.webp",
    platform: "PG",
    name: "Cocktail Nights",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-090",
  },
  {
    img: "/assets/slot/pgs_butterfly_blossom.webp",
    platform: "PG",
    name: "Butterfly Blossom",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-096",
  },
  {
    img: "/assets/slot/pgs_double_fortune.webp",
    platform: "PG",
    name: "Double Fortune",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-030",
  },
  {
    img: "/assets/slot/pgs_captains_bounty.webp",
    platform: "PG",
    name: "Captain's Bounty",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-034",
  },
  {
    img: "/assets/slot/pgs_jurassic_kingdom.webp",
    platform: "PG",
    name: "Jurassic Kingdom",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-079",
  },
  {
    img: "/assets/slot/pgs_ganesha_gold.webp",
    platform: "PG",
    name: "Ganesha Gold",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-026",
  },
  {
    img: "/assets/slot/pgs_grimms_bounty_hansel__gretel.webp",
    platform: "PG",
    name: "Grimms' Bounty: Hansel & Gretel",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-162",
  },
  {
    img: "/assets/slot/pgs_galaxy_miner.webp",
    platform: "PG",
    name: "Galaxy Miner",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-161",
  },
  {
    img: "/assets/slot/pgs_dragons_treasure_quest.webp",
    platform: "PG",
    name: "Dragon's Treasure Quest",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-160",
  },
  {
    img: "/assets/slot/pgs_diner_frenzy_spins.webp",
    platform: "PG",
    name: "Diner Frenzy Spins",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-159",
  },
  {
    img: "/assets/slot/pgs_jack_the_giant_hunter.webp",
    platform: "PG",
    name: "Jack the Giant Hunter",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-158",
  },
  {
    img: "/assets/slot/pgs_dead_mans_riches.webp",
    platform: "PG",
    name: "Dead Man's Riches",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-157",
  },
  {
    img: "/assets/slot/pgs_knockout_riches.webp",
    platform: "PG",
    name: "Knockout Riches",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-156",
  },
  {
    img: "/assets/slot/pgs_doomsday_rampage.webp",
    platform: "PG",
    name: "Doomsday Rampage",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-155",
  },
  {
    img: "/assets/slot/pgs_graffiti_rush.webp",
    platform: "PG",
    name: "Graffiti Rush",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-154",
  },
  // {
  //   img: "/assets/slot/pgs_mr_treasures_fortune.webp",
  //   platform: "PG",
  //   name: "Mr. Treasure's Fortune",
  // },
  {
    img: "/assets/slot/pgs_incan_wonders.webp",
    platform: "PG",
    name: "Incan Wonders",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-152",
  },
  {
    img: "/assets/slot/pgs_majestic_empire.webp",
    platform: "PG",
    name: "Majestic Empire",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-163",
  },
  {
    img: "/assets/slot/pgs_kraken_gold_rush.webp",
    platform: "PG",
    name: "Kraken Gold Rush",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-164",
  },
  {
    img: "/assets/slot/pgs_pharaoh_royals.webp",
    platform: "PG",
    name: "Pharaoh Royals",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-165",
  },
  {
    img: "/assets/slot/pgs_skylight_wonders.webp",
    platform: "PG",
    name: "Skylight Wonders",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-166",
  },
  {
    img: "/assets/slot/pgs_alibabas_cave_of_fortune.webp",
    platform: "PG",
    name: "Alibaba's Cave of Fortune",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-167",
  },
  // {
  //   img: "/assets/slot/pgs_poker_kingdom_win.webp",
  //   platform: "PG",
  //   name: "Poker Kingdom Win",
  // },
  {
    img: "/assets/slot/pgs_fortune_snake.webp",
    platform: "PG",
    name: "Fortune Snake",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-151",
  },
  {
    img: "/assets/slot/pgs_geishas_revenge.webp",
    platform: "PG",
    name: "Geisha's Revenge",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-150",
  },
  {
    img: "/assets/slot/pgs_chocolate_deluxe.webp",
    platform: "PG",
    name: "Chocolate Deluxe",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-149",
  },
  {
    img: "/assets/slot/pgs_rio_fantasia.webp",
    platform: "PG",
    name: "Rio Fantasia",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-148",
  },
  // {
  //   img: "/assets/slot/pgs_museum_mystery.webp",
  //   platform: "PG",
  //   name: "Museum Mystery",
  // },
  {
    img: "/assets/slot/rtg_golden_offer.webp",
    platform: "RT",
    name: "Golden Offer",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-028",
  },
  {
    img: "/assets/slot/rtg_bounty_raid.webp",
    platform: "RT",
    name: "Bounty Raid",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-124",
  },
  {
    img: "/assets/slot/rtg_primate_king.webp",
    platform: "RT",
    name: "Primate King",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-203",
  },
  {
    img: "/assets/slot/rtg_777_strike.webp",
    platform: "RT",
    name: "777 Strike",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-103",
  },
  {
    img: "/assets/slot/rtg_reel_heist.webp",
    platform: "RT",
    name: "Reel Heist",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-065",
  },
  {
    img: "/assets/slot/rtg_persian_fortune.webp",
    platform: "RT",
    name: "Persian Fortune",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-055",
  },
  {
    img: "/assets/slot/rtg_10001_nights.webp",
    platform: "RT",
    name: "10,001 Nights",
  },
  {
    img: "/assets/slot/rtg_neon_links.webp",
    platform: "RT",
    name: "Neon Links",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-207",
  },
  {
    img: "/assets/slot/rtg_rio_stars.webp",
    platform: "RT",
    name: "Rio Stars",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-099",
  },
  {
    img: "/assets/slot/rtg_gems_gone_wild_power_reels.webp",
    platform: "RT",
    name: "Gems Gone Wild Power Reels",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-148",
  },
  {
    img: "/assets/slot/rtg_wild_circus.webp",
    platform: "RT",
    name: "Wild Circus",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-083",
  },
  {
    img: "/assets/slot/rtg_golden_tsar.webp",
    platform: "RT",
    name: "Golden Tsar",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-150",
  },
  {
    img: "/assets/slot/rtg_pirates_plenty.webp",
    platform: "RT",
    name: "Pirates' Plenty",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-140",
  },
  {
    img: "/assets/slot/rtg_path_of_destiny.webp",
    platform: "RT",
    name: "Path of Destiny",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-125",
  },
  {
    img: "/assets/slot/rtg_grand_wheel.webp",
    platform: "RT",
    name: "Grand Wheel",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-029",
  },
  {
    img: "/assets/slot/rtg_god_of_wealth.webp",
    platform: "RT",
    name: "God of Wealth",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-025",
  },
  {
    img: "/assets/slot/rtg_fortune_house.webp",
    platform: "RT",
    name: "Fortune House",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-021",
  },
  {
    img: "/assets/slot/rtg_mystic_wheel.webp",
    platform: "RT",
    name: "Mystic Wheel",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-052",
  },
  {
    img: "/assets/slot/rtg_phoenix_fire_power_reels.webp",
    platform: "RT",
    name: "Phoenix Fire Power Reels",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-056",
  },
  {
    img: "/assets/slot/rtg_gold_star.webp",
    platform: "RT",
    name: "Gold Star",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-026",
  },
  {
    img: "/assets/slot/rtg_play_with_the_devil_megaways.webp",
    platform: "RT",
    name: "Play with the Devil MegaWays",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-282",
  },
  {
    img: "/assets/slot/rtg_fish_n_fish.webp",
    platform: "RT",
    name: "Fish n Fish",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-363",
  },
  {
    img: "/assets/slot/rtg_thors_rage.webp",
    platform: "RT",
    name: "Thor's Rage",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-360",
  },
  {
    img: "/assets/slot/rtg_aztec_shamans_megaways.webp",
    platform: "RT",
    name: "Aztec Shamans MegaWays",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-361",
  },
  {
    img: "/assets/slot/rtg_big_gains.webp",
    platform: "RT",
    name: "Big Gains",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-358",
  },
  {
    img: "/assets/slot/rtg_rise_of_cleopatra.webp",
    platform: "RT",
    name: "Rise of Cleopatra",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-351",
  },
  {
    img: "/assets/slot/rtg_777_diamond_strike.webp",
    platform: "RT",
    name: "777 Diamond Strike",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-352",
  },
  {
    img: "/assets/slot/rtg_zaidas_fortune.webp",
    platform: "RT",
    name: "Zaida's Fortune",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-186",
  },
  {
    img: "/assets/slot/rtg_cash_goddess.webp",
    platform: "RT",
    name: "Cash Goddess",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-353",
  },
  {
    img: "/assets/slot/rtg_wild_expedition.webp",
    platform: "RT",
    name: "Wild Expedition",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-218",
  },
  {
    img: "/assets/slot/rtg_viral_spiral.webp",
    platform: "RT",
    name: "Viral Spiral",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-132",
  },
  {
    img: "/assets/slot/rtg_wanted_wildz.webp",
    platform: "RT",
    name: "Wanted Wildz",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-280",
  },
  {
    img: "/assets/slot/rtg_wild_tundra.webp",
    platform: "RT",
    name: "Wild Tundra",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-189",
  },
  {
    img: "/assets/slot/rtg_risque_megaways.webp",
    platform: "RT",
    name: "Risque Megaways",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-185",
  },
  {
    img: "/assets/slot/rtg_mayhem.webp",
    platform: "RT",
    name: "Mayhem",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-181",
  },
  {
    img: "/assets/slot/rtg_miami_rise.webp",
    platform: "RT",
    name: "Miami Rise",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-354",
  },
  {
    img: "/assets/slot/rtg_last_chance_saloon.webp",
    platform: "RT",
    name: "Last Chance Saloon",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-176",
  },
  {
    img: "/assets/slot/rtg_jingle_ways_megaways.webp",
    platform: "RT",
    name: "Jingle Ways Megaways",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-171",
  },
  {
    img: "/assets/slot/rtg_jelly_multihops.webp",
    platform: "RT",
    name: "Jelly Multihops",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-246",
  },
  {
    img: "/assets/slot/rtg_hustling.webp",
    platform: "RT",
    name: "Hustling",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-173",
  },
  {
    img: "/assets/slot/rtg_hot_hot_chilli_pot.webp",
    platform: "RT",
    name: "Hot Hot Chilli Pot",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-219",
  },
  {
    img: "/assets/slot/rtg_get_the_gold_infinireels.webp",
    platform: "RT",
    name: "Get The Gold InfiniReels",
    platFormCode: "RT",
    gameType: "SLOT",
    casinoType: "RT-SLOT-174",
  },

  {
    img: "/assets/slot/nlc_folsom_prison.webp",
    platform: "NOLIMIT",
    name: "Folsom Prison",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-007",
  },
  {
    img: "/assets/slot/nlc_mayan_magic_wildfire.webp",
    platform: "NOLIMIT",
    name: "Mayan Magic Wildfire",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-048",
  },
  {
    img: "/assets/slot/nlc_book_of_shadows.webp",
    platform: "NOLIMIT",
    name: "Book Of Shadows",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-016",
  },
  {
    img: "/assets/slot/nlc_buffalo_hunter.webp",
    platform: "NOLIMIT",
    name: "Buffalo Hunter",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-033",
  },
  {
    img: "/assets/slot/nlc_punk_toilet.webp",
    platform: "NOLIMIT",
    name: "Punk Toilet",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-003",
  },
  {
    img: "/assets/slot/nlc_wixx.webp",
    platform: "NOLIMIT",
    name: "WiXX",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-060",
  },
  {
    img: "/assets/slot/nlc_misery_mining.webp",
    platform: "NOLIMIT",
    name: "Misery Mining",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-015",
  },
  {
    img: "/assets/slot/nlc_fire_in_the_hole_xbomb.webp",
    platform: "NOLIMIT",
    name: "Fire In The Hole xBomb",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-008",
  },
  {
    img: "/assets/slot/nlc_gaelic_gold.webp",
    platform: "NOLIMIT",
    name: "Gaelic Gold",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-038",
  },
  {
    img: "/assets/slot/nlc_thor_hammer_time.webp",
    platform: "NOLIMIT",
    name: "Thor Hammer Time",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-046",
  },
  {
    img: "/assets/slot/nlc_infectious_5_xways.webp",
    platform: "NOLIMIT",
    name: "Infectious 5 xWays",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-014",
  },
  {
    img: "/assets/slot/nlc_true_grit_redemption.webp",
    platform: "NOLIMIT",
    name: "True Grit Redemption",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-025",
  },
  {
    img: "/assets/slot/nlc_casino_win_spin.webp",
    platform: "NOLIMIT",
    name: "Casino Win Spin",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-058",
  },
  {
    img: "/assets/slot/nlc_monkeys_gold_xpays.webp",
    platform: "NOLIMIT",
    name: "Monkey's Gold xPays",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-032",
  },
  {
    img: "/assets/slot/nlc_golden_genie__the_walking_wilds.webp",
    platform: "NOLIMIT",
    name: "Golden Genie & the Walking Wilds",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-035",
  },
  {
    img: "/assets/slot/nlc_fruits.webp",
    platform: "NOLIMIT",
    name: "Fruits",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-052",
  },
  {
    img: "/assets/slot/nlc_deadwood_xnudge.webp",
    platform: "NOLIMIT",
    name: "Deadwood xNudge",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-010",
  },
  {
    img: "/assets/slot/nlc_tombstone_rip.webp",
    platform: "NOLIMIT",
    name: "Tombstone RIP",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-006",
  },
  {
    img: "/assets/slot/nlc_tombstone.webp",
    platform: "NOLIMIT",
    name: "Tombstone",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-049",
  },
  {
    img: "/assets/slot/nlc_xways_hoarder_2.webp",
    platform: "NOLIMIT",
    name: "xWays Hoarder 2",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-105",
  },
  {
    img: "/assets/slot/nlc_outsourced_payday.webp",
    platform: "NOLIMIT",
    name: "Outsourced: Payday",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-101",
  },
  {
    img: "/assets/slot/nlc_munchies.webp",
    platform: "NOLIMIT",
    name: "Munchies",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-099",
  },
  {
    img: "/assets/slot/nlc_tanked.webp",
    platform: "NOLIMIT",
    name: "Tanked",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-102",
  },
  {
    img: "/assets/slot/nlc_blood__shadow_2.webp",
    platform: "NOLIMIT",
    name: "Blood & Shadow 2",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-100",
  },
  {
    img: "/assets/slot/nlc_apocalypse_super_xnudge.webp",
    platform: "NOLIMIT",
    name: "Apocalypse Super xNudge",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-092",
  },
  {
    img: "/assets/slot/nlc_stockholm_syndrome.webp",
    platform: "NOLIMIT",
    name: "Stockholm Syndrome",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-094",
  },
  {
    img: "/assets/slot/nlc_skate_or_die.webp",
    platform: "NOLIMIT",
    name: "Skate or Die",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-095",
  },
  {
    img: "/assets/slot/nlc_brute_force.webp",
    platform: "NOLIMIT",
    name: "Brute Force",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-097",
  },
  {
    img: "/assets/slot/nlc_san_quentin_2_death_row.webp",
    platform: "NOLIMIT",
    name: "San Quentin 2: Death Row",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-096",
  },
  {
    img: "/assets/slot/nlc_outsourced.webp",
    platform: "NOLIMIT",
    name: "Outsourced",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-093",
  },
  {
    img: "/assets/slot/nlc_punk_rocker_2.webp",
    platform: "NOLIMIT",
    name: "Punk Rocker 2",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-089",
  },
  {
    img: "/assets/slot/nlc_beheaded.webp",
    platform: "NOLIMIT",
    name: "Beheaded",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-090",
  },
  {
    img: "/assets/slot/nlc_deadwood_rip.webp",
    platform: "NOLIMIT",
    name: "Deadwood R.I.P",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-091",
  },
  {
    img: "/assets/slot/nlc_loner.webp",
    platform: "NOLIMIT",
    name: "Loner",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-088",
  },
  {
    img: "/assets/slot/nlc_kenneth_must_die.webp",
    platform: "NOLIMIT",
    name: "Kenneth Must Die",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-087",
  },
  {
    img: "/assets/slot/nlc_tombstone_no_mercy.webp",
    platform: "NOLIMIT",
    name: "Tombstone: No Mercy",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-082",
  },
  {
    img: "/assets/slot/nlc_brick_snake_2000.webp",
    platform: "NOLIMIT",
    name: "Brick Snake 2000",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-075",
  },
  {
    img: "/assets/slot/nlc_possessed.webp",
    platform: "NOLIMIT",
    name: "Possessed",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-081",
  },
  {
    img: "/assets/slot/nlc_fire_in_the_hole_2.webp",
    platform: "NOLIMIT",
    name: "Fire in the Hole 2",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-078",
  },
  {
    img: "/assets/slot/nlc_d_day.webp",
    platform: "NOLIMIT",
    name: "D Day",
    platFormCode: "NLC",
    gameType: "SLOT",
    casinoType: "NLC-SLOT-076",
  },
  {
    img: "/assets/slot/S-CS02_0.webp",
    platform: "SPADE",
    name: "Caishen",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-109",
  },
  {
    img: "/assets/slot/S-FS02_0.webp",
    platform: "SPADE",
    name: "Fiery Sevens Exclusive",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-106",
  },
  {
    img: "/assets/slot/S-LK02_0.webp",
    platform: "SPADE",
    name: "Lucky Koi Exclusive",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-107",
  },
  {
    img: "/assets/slot/S-JT03_0.webp",
    platform: "SPADE",
    name: "Jokers Treasure Exclusive",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-075",
  },
  {
    img: "/assets/slot/S-TD01_0.webp",
    platform: "SPADE",
    name: "Tiger Dance",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-104",
  },
  {
    img: "/assets/slot/S-RH02_0.webp",
    platform: "SPADE",
    name: "Royale House",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-105",
  },
  {
    img: "/assets/slot/S-VB01_0.webp",
    platform: "SPADE",
    name: "Sexy Vegas",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-103",
  },
  {
    img: "/assets/slot/S-RM01_0.webp",
    platform: "SPADE",
    name: "Roma",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-102",
  },
  {
    img: "/assets/slot/S-WW02_0.webp",
    platform: "SPADE",
    name: "Wild Wet Win",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-099",
  },
  {
    img: "/assets/slot/S-RK02_0.webp",
    platform: "SPADE",
    name: "Royal Katt",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-098",
  },
  {
    img: "/assets/slot/S-RC01_0.webp",
    platform: "SPADE",
    name: "Rich Caishen",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-096",
  },
  {
    img: "/assets/slot/S-MT01_0.webp",
    platform: "SPADE",
    name: "Muay Thai Fighter",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-097",
  },
  {
    img: "/assets/slot/S-PW03_0.webp",
    platform: "SPADE",
    name: "Poker Ways",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-095",
  },
  {
    img: "/assets/slot/S-LI03_0.webp",
    platform: "SPADE",
    name: "Love Idol",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-093",
  },
  {
    img: "/assets/slot/S-MK01_0.webp",
    platform: "SPADE",
    name: "Magic Kitty",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-091",
  },
  {
    img: "/assets/slot/S-CB02_0.webp",
    platform: "SPADE",
    name: "Sugar Bonanza",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-092",
  },
  {
    img: "/assets/slot/S-HQ01_0.webp",
    platform: "SPADE",
    name: "Hugon Quest",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-089",
  },
  // {
  //   img: "/assets/slot/S-LB01_0.webp",
  //   platform: "SPADE",
  //   name: "Legendary Beasts Saga",
  // },
  {
    img: "/assets/slot/S-CP02_0.webp",
    platform: "SPADE",
    name: "Candy Candy",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-101",
  },
  {
    img: "/assets/slot/S-GR01_0.webp",
    platform: "SPADE",
    name: "Gold Rush Cowboys",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-100",
  },
  {
    img: "/assets/slot/S-BA01_0.webp",
    platform: "SPADE",
    name: "888",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-069",
  },
  // {
  //   img: "/assets/slot/S-DE01_0.webp",
  //   platform: "SPADE",
  //   name: "Dragon Empire",
  // },
  {
    img: "/assets/slot/S-MM01_0.webp",
    platform: "SPADE",
    name: "Money Mouse",
    platFormCode: "PP",
    gameType: "SLOT",
    casinoType: "PP-SLOT-064",
  },

  {
    img: "/assets/slot/S-MG02_0.webp",
    platform: "SPADE",
    name: "Mayan Gems",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-086",
  },
  {
    img: "/assets/slot/S-RW01_0.webp",
    platform: "SPADE",
    name: "Rise Of Werewolves",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-087",
  },

  {
    img: "/assets/slot/S-ZE01_0.webp",
    platform: "SPADE",
    name: "ZEUS",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-097",
  },

  {
    img: "/assets/slot/S-BM01_0.webp",
    platform: "SPADE",
    name: "Book of Myth",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-077",
  },
  {
    img: "/assets/slot/S-JT02_0.webp",
    platform: "SPADE",
    name: "Jokers Treasure",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-075",
  },
  {
    img: "/assets/slot/S-MG01_0.webp",
    platform: "SPADE",
    name: "Mega 7",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-074",
  },
  {
    img: "/assets/slot/S-FS01_0.webp",
    platform: "SPADE",
    name: "Fiery Sevens",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-079",
  },
  {
    img: "/assets/slot/S-CB01_0.webp",
    platform: "SPADE",
    name: "Crazy Bomber",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-078",
  },
  {
    img: "/assets/slot/S-SB01_0.webp",
    platform: "SPADE",
    name: "Sweet Bakery",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-072",
  },
  {
    img: "/assets/slot/S-LS02_0.webp",
    platform: "SPADE",
    name: "Three Lucky Stars",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-073",
  },
  {
    img: "/assets/slot/S-HE01_0.webp",
    platform: "SPADE",
    name: "Heroes",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-068",
  },
  {
    img: "/assets/slot/S-WP02_0.webp",
    platform: "SPADE",
    name: "Wow Prosperity",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-006",
  },
  // {
  //     "img": "/assets/slot/S-WC02_0.webp",
  //     "platform": "SPADE",
  //     "name": "Wong Choy",
  //     "platFormCode": "NLC",
  //     "gameType": "SLOT",
  //     "casinoType": null
  // },
  {
    img: "/assets/slot/S-TP02_0.webp",
    platform: "SPADE",
    name: "Triple Panda",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-081",
  },
  {
    img: "/assets/slot/S-TW01_0.webp",
    platform: "SPADE",
    name: "Tiger Warrior",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-014",
  },
  {
    img: "/assets/slot/S-PG01_0.webp",
    platform: "SPADE",
    name: "Prosperity Gods",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-085",
  },
  {
    img: "/assets/slot/S-PW02_0.webp",
    platform: "SPADE",
    name: "Princess Wang",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-005",
  },

  {
    img: "/assets/slot/S-CH01_0.webp",
    platform: "SPADE",
    name: "Mr Chu Tycoon",
    platFormCode: "SPADE",
    gameType: "SLOT",
    casinoType: "SG-SLOT-083",
  },
];
export const Table = [
  {
    img: "/assets/table/6377725645da8.webp",
    platform: "JILI",
    name: "Ludo Quick",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-021",
  },
  {
    img: "/assets/table/646df399f3b7d.webp",
    platform: "JILI",
    name: "Golden Land",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-027",
  },
  {
    img: "/assets/table/68c0ff2c7d242.webp",
    platform: "JILI",
    name: "Crash Puck",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-081",
  },
  {
    img: "/assets/table/68ca3dc64e710.webp",
    platform: "JILI",
    name: "Chicken Dash",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-082",
  },
  {
    img: "/assets/table/68ef1b0907ff2.webp",
    platform: "JILI",
    name: "Drop Ball",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-086",
  },
  {
    img: "/assets/table/6901dd4315815.webp",
    platform: "JILI",
    name: "Mines Grand",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-076",
  },
  {
    img: "/assets/table/6901de381480e.webp",
    platform: "JILI",
    name: "Jogo do Bicho",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-052",
  },
  {
    img: "/assets/table/690af2dd5ffd3.webp",
    platform: "JILI",
    name: "Frog Dash",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-088",
  },
  {
    img: "/assets/table/663b91b6d4f28.webp",
    platform: "JILI",
    name: "Speed Baccarat",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-054",
  },
  {
    img: "/assets/table/65e98d20d97e3.webp",
    platform: "JILI",
    name: "Video Poker",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-050",
  },
  {
    img: "/assets/table/65c0919831b61.webp",
    platform: "JILI",
    name: "European Roulette",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-053",
  },
  {
    img: "/assets/table/6583b32e5fbc3.webp",
    platform: "JILI",
    name: "Caribbean Stud Poker",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-049",
  },
  {
    img: "/assets/table/657281362535f.webp",
    platform: "JILI",
    name: "Pool Rummy",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-048",
  },
  {
    img: "/assets/table/65373ac1767f4.webp",
    platform: "JILI",
    name: "MiniFlush",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-042",
  },
  {
    img: "/assets/table/6527bcba09af2.webp",
    platform: "JILI",
    name: "Blackjack Lucky Ladies",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-046",
  },
  {
    img: "/assets/table/651f8f04d3d1d.webp",
    platform: "JILI",
    name: "HILO",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-032",
  },
  {
    img: "/assets/table/6501af7d08e88.webp",
    platform: "JILI",
    name: "Color Prediction",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-039",
  },
  {
    img: "/assets/table/64d5df2b48b36.webp",
    platform: "JILI",
    name: "Candyland Bingo",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-043",
  },
  {
    img: "/assets/table/64ca22b7a40b9.webp",
    platform: "JILI",
    name: "Plinko",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-041",
  },
  {
    img: "/assets/table/64ae3771a7c97.webp",
    platform: "JILI",
    name: "Keno",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-040",
  },
  {
    img: "/assets/table/64abca220a3b8.webp",
    platform: "JILI",
    name: "Mines Gold",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-037",
  },
  {
    img: "/assets/table/64956737f22af.webp",
    platform: "JILI",
    name: "Pusoy Go",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-038",
  },
  {
    img: "/assets/table/646c392694eb7.webp",
    platform: "JILI",
    name: "Go Rush",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-030",
  },
  {
    img: "/assets/table/6451172d9bdfa.webp",
    platform: "JILI",
    name: "Tower",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-031",
  },
  {
    img: "/assets/table/63f1d5aa2ceda.webp",
    platform: "JILI",
    name: "Tongits Go",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-025",
  },
  {
    img: "/assets/table/63f1d516e06c0.webp",
    platform: "JILI",
    name: "Calaca Bingo",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-026",
  },
  {
    img: "/assets/table/63f1d4c6c9e5f.webp",
    platform: "JILI",
    name: "Go Goal Bingo",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-022",
  },
  {
    img: "/assets/table/63f1d4557f0c1.webp",
    platform: "JILI",
    name: "Color Game",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-023",
  },
  {
    img: "/assets/table/63f1d425cd836.webp",
    platform: "JILI",
    name: "Jackpot Bingo",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-024",
  },
  {
    img: "/assets/table/63f1d3e9ef0da.webp",
    platform: "JILI",
    name: "Lucky Bingo",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-020",
  },
  {
    img: "/assets/table/6304b40fca566.webp",
    platform: "JILI",
    name: "Bingo Carnaval",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-019",
  },
  {
    img: "/assets/table/125_0.webp",
    platform: "JILI",
    name: "Sic Bo",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-017",
  },
  {
    img: "/assets/table/161_0.webp",
    platform: "JILI",
    name: "TeenPatti 20-20",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-016",
  },
  {
    img: "/assets/table/160_0.webp",
    platform: "JILI",
    name: "Callbreak Quick",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-013",
  },
  {
    img: "/assets/table/152_0.webp",
    platform: "JILI",
    name: "Baccarat",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-014",
  },
  {
    img: "/assets/table/159_0.webp",
    platform: "JILI",
    name: "TeenPatti Joker",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-010",
  },
  {
    img: "/assets/table/127_0.webp",
    platform: "JILI",
    name: "Callbreak",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-009",
  },
  {
    img: "/assets/table/94_0.webp",
    platform: "JILI",
    name: "Rummy",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-004",
  },
  {
    img: "/assets/table/79_0.webp",
    platform: "JILI",
    name: "Andar Bahar",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-003",
  },
  {
    img: "/assets/table/75_0.webp",
    platform: "JILI",
    name: "AK47",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-002",
  },
  {
    img: "/assets/table/72_0.webp",
    platform: "JILI",
    name: "TeenPatti",
  },
  {
    img: "/assets/table/124_0.webp",
    platform: "JILI",
    name: "7up7down",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-011",
  },
  {
    img: "/assets/table/122_0.webp",
    platform: "JILI",
    name: "iRich Bingo",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-008",
  },
  {
    img: "/assets/table/123_0.webp",
    platform: "JILI",
    name: "Dragon & Tiger",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-012",
  },
  {
    img: "/assets/table/113_0.webp",
    platform: "JILI",
    name: "Poker King",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-006",
  },
  // {
  //   img: "/assets/table/112_0.webp",
  //   platform: "JILI",
  //   name: "Journey West M",
  // },
  {
    img: "/assets/table/111_0.webp",
    platform: "JILI",
    name: "Number King",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-005",
  },
  {
    img: "/assets/table/63f1d3a489eb8.webp",
    platform: "JILI",
    name: "Win Drop",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-061",
  },
  {
    img: "/assets/table/64f0042e97b7a.webp",
    platform: "KM",
    name: "KM Virtual Animal Race",
    platFormCode: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-062",
  },
  {
    img: "/assets/table/64e3317e3d76f.webp",
    platform: "KM",
    name: "Ludo",
    platFormCode: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-060",
  },
  {
    img: "/assets/table/64e33142f1edc.webp",
    platform: "KM",
    name: "KM Virtual Treadmill Racing",
    platFormCode: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-058",
  },
  {
    img: "/assets/table/64e3311ba48d6.webp",
    platform: "KM",
    name: "KM Virtual Greyhound Racing",
    platFormCode: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-055",
  },
  {
    img: "/assets/table/64e330d3694b3.webp",
    platform: "KM",
    name: "Marble Knockout",
    platFormCode: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-053",
  },
  // {
  //   img: "/assets/table/64e330abd978a.webp",
  //   platform: "KM",
  //   name: "Bola Tangkas",
  // },
  // {
  //   img: "/assets/table/64e330790387a.webp",
  //   platform: "KM",
  //   name: "Bingo Roll",
  // },
  {
    img: "/assets/table/64e33038057b7.webp",
    platform: "KM",
    name: "Colour Game",
    platFormCode: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-050",
  },
  {
    img: "/assets/table/KM-TABLE-049_0.webp",
    platform: "KM",
    name: "5CardPoker",
    gameType: "TABLE",
    casinoType: "KM-TABLE-049",
    platFormCode: "KINGMAKER",
  },
  {
    img: "/assets/table/KM-TABLE-048_0.webp",
    platform: "KM",
    name: "HorseRacing",
    platFormCode: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-048",
  },
  {
    img: "/assets/table/KM-TABLE-046_0.webp",
    platform: "KM",
    name: "Teen Patti",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-001",
  },
  {
    img: "/assets/table/KM-TABLE-045_0.webp",
    platform: "KM",
    name: "Monkey King Roulette",
    platFormCode: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-045",
  },
  {
    img: "/assets/table/KM-TABLE-044_0.webp",
    platform: "KM",
    name: "Dota Hi-Lo",
    platFormCode: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-044",
  },
  {
    img: "/assets/table/KM-TABLE-043_0.webp",
    platform: "KM",
    name: "Bonus Dice",
    platFormCode: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-043",
  },
  {
    img: "/assets/table/KM-TABLE-040_0.webp",
    platform: "KM",
    name: "Plinko",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-041",
  },
  {
    img: "/assets/table/KM-TABLE-039_0.webp",
    platform: "KM",
    name: "32 Cards",
    platFormCode: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-039",
  },
  {
    img: "/assets/table/KM-TABLE-038_0.webp",
    platform: "KM",
    name: "Blackjack",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-044",
  },
  {
    img: "/assets/table/KM-TABLE-037_0.webp",
    platform: "KM",
    name: "Cards Hi Lo",
    platFormCode: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-037",
  },
  {
    img: "/assets/table/KM-TABLE-036_0.webp",
    platform: "KM",
    name: "Coin Toss",
    platFormCode: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-036",
  },
  {
    img: "/assets/table/KM-TABLE-042_0.webp",
    platform: "KM",
    name: "Minesweeper",
    platFormCode: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-042",
  },
  {
    img: "/assets/table/KM-TABLE-041_0.webp",
    platform: "KM",
    name: "Cash Rocket",
    platFormCode: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-041",
  },
  {
    img: "/assets/table/KM-TABLE-035_0.webp",
    platform: "KM",
    name: "Bola Golek",
    platFormCode: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-035",
  },
  {
    img: "/assets/table/KM-TABLE-034_0.webp",
    platform: "KM",
    name: "Kingmaker Pok Deng",
    gameType: "TABLE",
    casinoType: "KM-TABLE-034",
    platFormCode: "KINGMAKER",
  },
  {
    img: "/assets/table/KM-TABLE-033_0.webp",
    platform: "KM",
    name: "Pai Kang",
    platFormCode: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-033",
  },
  {
    img: "/assets/table/KM-TABLE-032_0.webp",
    platform: "KM",
    name: "Andar Bahar",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-003",
  },
  {
    img: "/assets/table/KM-TABLE-026_0.webp",
    platform: "KM",
    name: "Baccarat",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-014",
  },
  {
    img: "/assets/table/KM-TABLE-030_0.webp",
    platform: "KM",
    name: "Jhandi Munda",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-056",
  },
  {
    img: "/assets/table/KM-TABLE-029_0.webp",
    platform: "KM",
    name: "Bai Buu",
    platFormCode: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-029",
  },
  {
    img: "/assets/table/KM-TABLE-028_0.webp",
    platform: "KM",
    name: "7 Up 7 Down",
    platFormCode: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-028",
  },
  {
    img: "/assets/table/KM-TABLE-027_0.webp",
    platform: "KM",
    name: "European Roulette",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-053",
  },
  {
    img: "/assets/table/KM-TABLE-025_0.webp",
    platform: "KM",
    name: "Fruit Roulette",
    platFormCode: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-025",
  },
  // {
  //   img: "/assets/table/KM-TABLE-024_0.webp",
  //   platform: "KM",
  //   name: "Fan Tan Classic",
  // },
  {
    img: "/assets/table/KM-TABLE-023_0.webp",
    platform: "KM",
    name: "Xocdia2",
    platFormCode: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-023",
  },
  {
    img: "/assets/table/KM-TABLE-022_0.webp",
    platform: "KM",
    name: "CardMatka",
    gameType: "TABLE",
    casinoType: "KM-TABLE-022",
    platFormCode: "KINGMAKER",
  },
  {
    img: "/assets/table/KM-TABLE-021_0.webp",
    platform: "KM",
    name: "NumberMatka",
    gameType: "TABLE",
    casinoType: "KM-TABLE-021",
    platFormCode: "KINGMAKER",
  },
  {
    img: "/assets/table/KM-TABLE-020_0.webp",
    platform: "KM",
    name: "Bài Cào",
    platFormCode: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-020",
  },
  {
    img: "/assets/table/KM-TABLE-019_0.webp",
    platform: "KM",
    name: "Thai-FPC",
    platFormCode: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-019",
  },
  {
    img: "/assets/table/KM-TABLE-018_0.webp",
    platform: "KM",
    name: "Keno",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-040",
  },
  {
    img: "/assets/table/KM-TABLE-017_0.webp",
    platform: "KM",
    name: "TaiXiu",
    platFormCode: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-017",
  },
  {
    img: "/assets/table/KM-TABLE-015_0.webp",
    platform: "KM",
    name: "Sicbo",
    platFormCode: "KINGMAKER",
    gameType: "TABLE",
    casinoType: "KM-TABLE-015",
  },
  {
    img: "/assets/table/KM-TABLE-014_0.webp",
    platform: "KM",
    name: "VN Fish Prawn Crab",
    gameType: "TABLE",
    casinoType: "KM-TABLE-089",
    platFormCode: "KINGMAKER",
  },
  {
    img: "/assets/table/KM-TABLE-013_0.webp",
    platform: "KM",
    name: "Fish Prawn Crab 2",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-100",
  },
];

export const Crash = [
  {
    img: "/assets/crash/682bb30722524.webp",
    platform: "AVIATOR",
    name: "Aviator Studio",
    platFormCode: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-001",
  },
  {
    img: "/assets/crash/spb_aviator.webp",
    platform: "SPRIBE",
    name: "Aviator",
    platFormCode: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-001",
  },
  {
    img: "/assets/crash/spb_mines.webp",
    platform: "SPRIBE",
    name: "Mines",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-033",
  },
  {
    img: "/assets/crash/spb_mini_roulette.webp",
    platform: "SPRIBE",
    name: "Mini Roulette",
    platFormCode: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-008",
  },
  {
    img: "/assets/crash/spb_hi_lo.webp",
    platform: "SPRIBE",
    name: "Hi Lo",
    platFormCode: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-006",
  },
  {
    img: "/assets/crash/spb_plinko.webp",
    platform: "SPRIBE",
    name: "Plinko",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-041",
  },
  {
    img: "/assets/crash/spb_dice.webp",
    platform: "SPRIBE",
    name: "Dice",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-033",
  },
  {
    img: "/assets/crash/spb_goal.webp",
    platform: "SPRIBE",
    name: "Goal",
    platFormCode: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-002",
  },
  {
    img: "/assets/crash/spb_hotline.webp",
    platform: "SPRIBE",
    name: "Hotline",
    platFormCode: "SPRIBE",
    gameType: "EGAME",
    casinoType: "SPRIBE-EGAME-009",
  },
  {
    img: "/assets/crash/653117cc2e7ef.webp",
    platform: "JILI",
    name: "Crash Bonus",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-047",
  },
  {
    img: "/assets/crash/64e71488aae04.webp",
    platform: "JILI",
    name: "Mines",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-033",
  },
  {
    img: "/assets/crash/647708fd83d06.webp",
    platform: "JILI",
    name: "Wheel",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-036",
  },
  {
    img: "/assets/crash/647708867b175.webp",
    platform: "JILI",
    name: "Limbo",
    platFormCode: "JILI",
    gameType: "TABLE",
    casinoType: "JILI-TABLE-035",
  },
];

export const Fishing = [
  {
    img: "/assets/fishing/674d40e43fc7c.webp",
    platform: "JILI",
    name: "Dinosaur Tycoon",
    platFormCode: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-004",
  },
  {
    img: "/assets/fishing/66d6f676aa78a.webp",
    platform: "JILI",
    name: "Dragon Fortune",
    platFormCode: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-006",
  },
  {
    img: "/assets/fishing/66d6f0779dfb4.webp",
    platform: "JILI",
    name: "Boom Legend",
    platFormCode: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-008",
  },
  {
    img: "/assets/fishing/653893f5a72e8.webp",
    platform: "JILI",
    name: "Ocean King Jackpot",
    platFormCode: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-012",
  },
  {
    img: "/assets/fishing/630e18f571cac.webp",
    platform: "JILI",
    name: "Bombing Fishing",
    platFormCode: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-002",
  },
  {
    img: "/assets/fishing/630e18bba58b3.webp",
    platform: "JILI",
    name: "Jackpot Fishing",
    platFormCode: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-003",
  },
  {
    img: "/assets/fishing/630e1817bf31e.webp",
    platform: "JILI",
    name: "Happy Fishing",
    platFormCode: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-005",
  },
  {
    img: "/assets/fishing/630e17adc26db.webp",
    platform: "JILI",
    name: "All-star Fishing",
    platFormCode: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-009",
  },
  {
    img: "/assets/fishing/630e1865d83d2.webp",
    platform: "JILI",
    name: "Mega Fishing",
    platFormCode: "JILI",
    gameType: "FH",
    casinoType: "JILI-FISH-007",
  },
  {
    img: "/assets/fishing/F-AH01_0.webp",
    platform: "SPADE",
    name: "Alien Hunter",
    platFormCode: "SPADE",
    gameType: "FH",
    casinoType: "SG-FISH-003",
  },
  {
    img: "/assets/fishing/F-FL01_0.webp",
    platform: "SPADE",
    name: "Fishing Legend",
    platFormCode: "SPADE",
    gameType: "FH",
    casinoType: "SG-FISH-005",
  },
  {
    img: "/assets/fishing/F-ZP01_0.webp",
    platform: "SPADE",
    name: "Zombie Party",
    platFormCode: "SPADE",
    gameType: "FH",
    casinoType: "SG-FISH-004",
  },
  {
    img: "/assets/fishing/F-SF01_0.webp",
    platform: "SPADE",
    name: "Fishing God",
    platFormCode: "SPADE",
    gameType: "FH",
    casinoType: "SG-FISH-001",
  },
];
